import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { Observable, Subscription, tap , take, filter, firstValueFrom, takeUntil, Subject} from 'rxjs';
import { QuoteRejectComponent } from '../quote-reject/quote-reject.component';
import { QuoteDocumentComponent } from '../quote-document/quote-document.component';
import { PreviewQuoteComponent } from '../preview-quote/preview-quote.component';
import { QuotationExportService } from '../../services/quotation-export.service';
import { OrderStatusDialogService } from '../../services/order-status-dialog.service';
import { DATE_FORMAT, DEFAULT_LINES_PAGE_SIZE, TOAST_DURATION } from 'src/app/config/global.config';
import { ActivatedRoute, Router } from '@angular/router';
import { AcceptQuotation, AcceptQuotationSuccess, AppendQuotationPage, ArchiveQuotation, cancelQuotation, cancelQuotationSuccess, clearQuotations, deleteQuotation, deleteQuotationSuccess, DuplicateQuotation, EditAndSendQuotation, EditAndSendQuotationSuccess, EditDraftQuotation, EditDraftQuotationSuccess, EditQuotation, EditQuotationSuccess, GetQuotationById, GetQuotationSourceContent, invoiceQuotation, invoiceQuotationSuccess, MarkQuotationRead, PromptToOrder, PromptToOrderSuccess, ResendQuotation, ResendQuotationSuccess, SendQuotation, SendQuotationSuccess, SetQuotationsLoader, UnarchiveQuotation, UpdateEmailOrder, UpdateEmailOrderSuccess, UpdateAiNotes, UpdateAiNotesSuccess, UpdateOrderStatus, UpdatePaymentStatus, DismissSuggestedLocation, DismissDuplicateBadge, UpdateQuotationDetails, UpdateQuotationDetailsError, UpdateQuotationDetailsSuccess, UpdateQuotationLines, UpdateQuotationLinesSuccess, validateOrder, validateOrderSuccess } from '../../store/quotations.actions';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { selectCanDo } from 'src/app/core/store/permissions/permissions.selectors';
import { IErpMissingInventory, IErpMissingProduct, IExtractedNote, IOrderLineAlert, IParseProduct, IQuotationDetail, IQuotationSourceContent, IQuoteProductData, ISentToErpRespone, IUpdateQuotationDetails, IUpdateQuotationLinesPayload, PriceSourceType, withFallbackAttachments } from '../../models/quotations.models';
import { attachmentFileName, attachmentPathKey, findSourceAttachment, IOrderSourceLine } from '../../utils/order-source-attachment.util';
import { resolveAttentionCount, resolveLineCount } from '../../utils/line-composition.util';
import { LineCompositionPopoverComponent } from '../line-composition-popover/line-composition-popover.component';
import { MatMenuModule } from '@angular/material/menu';
import { roundPrice } from '../../utils/price-decimals.util';
import { Actions, ofType } from '@ngrx/effects';
import { EditQuotesComponent } from '../edit-quotes/edit-quotes.component';
import { OrderStatusEnum } from '../../enum/quotations.status.enum';
import { QuotesService } from '../../services/quotations.services';
import { PriceCandidatesStore } from '../../services/price-candidates.store';
import {
  IPriceCandidate,
  IPricePolicyTrace,
  applyPriceTitleKey,
  orderLineProductId,
  supportsApplyToAllProducts,
} from '../../models/quotations.models';
import { TranslateService } from '@ngx-translate/core';
import { GenerateInvoicePopUpComponent } from '../generate-invoice-pop-up/generate-invoice-pop-up.component';
import { getInternalPaymentStatus } from 'src/app/shared/utils/helpers';
import { handlingUnitBaseMultiplier, quantityInBaseUnitsTranslationParams, applyHandlingUnitRounding } from 'src/app/shared/utils/handling-unit.utils';
import { ConfirmationPopUpComponent } from 'src/app/shared/confirmation-pop-up/confirmation-pop-up.component';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import { OrderStatusConfirmComponent } from '../order-status-confirm/order-status-confirm.component';
import { DialogAction, DialogCheckbox, DialogStatus } from '../order-status-confirm/order-status-confirm.types';
import { environment } from 'src/environments/environment';
import { ICurrency, ILocation, IPayment_term } from 'src/app/features/customers/models/customers.models';
import { CustomersService } from 'src/app/features/customers/services/customers.services';
import { IFile, IProduct, IProductHandlingUnit, IProductInventoryDetails, IStockByWarehouse } from 'src/app/features/produits/models/products.models';
import { ProductsService } from 'src/app/features/produits/services/produits.services';
import { HandlingUnitsDialogueComponent } from 'src/app/features/produits/components/handling-units-dialogue/handling-units-dialogue.component';
import { MatAutocompleteTrigger, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { IPagination, IPageCount } from 'src/app/shared/models/page.model';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ClearProducts, FetchProductsBySearch } from 'src/app/features/produits/store/produits.actions';
import { IAskForQuotation, ISegregationInfo, ISegregationSplit } from '../../models/quotations.models';
import { ClearCatalog, GetCatalogById, GetProductsCatalogCompanyById, SetCatalogLoader } from 'src/app/features/catalogs/store/catalogs.actions';
import {
  LINKED_ORDERS_INLINE_MAX,
  LinkedOrdersModalComponent,
} from '../linked-orders-modal/linked-orders-modal.component';
import { EditCommentComponent } from '../edit-comment/edit-comment.component';
import { ProductNotesDialogComponent, IProductNotesDialogResult } from '../product-notes-dialog/product-notes-dialog.component';
import { CommonService } from 'src/app/shared/common.service';
import { MatchingMissingAiQuoteProductsComponent } from '../matching-missing-ai-quote-products/matching-missing-ai-quote-products.component';
import { CheckProductsAvailability,CheckProductsAvailabilitySuccess, CheckProductsAvailabilityError } from '../../store/quotations.actions';
import { ProductsAvailabilityDialogComponent } from '../products-availability-dialog/products-availability-dialog.component';
import { DuplicateProductsHandlerComponent } from '../duplicate-products-handler/duplicate-products-handler.component';
import { DeleteDuplicateProducts, DeleteDuplicateProductsSuccess } from '../../store/quotations.actions';
import { ErpSyncStatusChanged } from '../../store/quotations.actions';
import { PricebookService } from 'src/app/features/pricebook/services/pricebook.service';
import { IPriceBookViewDTO } from 'src/app/features/pricebook/models/pricebook.model';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { ProductCodeService } from 'src/app/core/services/product-code.service';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonComponent } from '../../../../ui/button/button.component';
import { SharedModule } from '../../../../shared/shared.module';
import { ExploreCatalogComponent } from 'src/app/features/new-orders/components/explore-catalogs/explore-catalog.component';
import { ProductsQuoteFromCatalogComponent } from '../products-quote-from-catalog/products-quote-from-catalog.component';
import { ProductsQuoteFromAllProductsComponent } from '../products-quote-from-all-products/products-quote-from-all-products.component';
import { QuotationsModule } from '../../quotations.module';
import { StockFulfillmentComponent } from './stock-fulfillment/stock-fulfillment.component';
import { OrderLineAlertsComponent } from '../order-line-alerts/order-line-alerts.component';
import { CompaniesSelectionDialogComponent } from 'src/app/features/new-orders/components/companies-selection-dialog/companies-selection-dialog.component';
import { SvgIconComponent as UiSvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';
import { IconComponent as UiIconComponent } from 'src/app/ui/icon/icon.component';
import { PromptToOrderComponent } from '../prompt-to-order/prompt-to-order.component';
import { EnrichCompanyEmailsDialogComponent } from '../enrich-company-emails-dialog/enrich-company-emails-dialog.component';
import { EnrichCompanyEmailsCardComponent, IEnrichCardSavedEvent } from '../enrich-company-emails-card/enrich-company-emails-card.component';
import { EnrichExternalReferencesDialogComponent, IEnrichCodeInput } from '../enrich-external-references-dialog/enrich-external-references-dialog.component';
import { CustomerEmailService } from 'src/app/features/knowledge-base/services/customer-email.service';
import { ExternalReferenceService } from 'src/app/features/knowledge-base/services/external-reference.service';
import { IExternalReference } from 'src/app/features/knowledge-base/models/external-reference.models';

import { IObjectCustomFields, IObjectCustomFieldsParams } from 'src/app/features/settings/models/settings.models';
import { CustomFieldTypes, CustomFieldVisibilityTypes, RelatedObjectsTypes } from 'src/app/features/settings/models/custom-fields.constants';
import { GetObjectCustomFields, UpdateObjectCustomFields } from 'src/app/features/settings/store/settings.actions';
import { LanguageService } from 'src/app/config/language.service';
import { ObjectCustomFieldsViewComponent } from 'src/app/shared/components/object-custom-fields-view/object-custom-fields-view.component';
import { OrderCustomFieldsComponent } from '../order-custom-fields/order-custom-fields.component';
import { SideBySideCorrectionPanelComponent } from '../side-by-side-correction-panel/side-by-side-correction-panel.component';
import { ChangeOrderOwnerDialogComponent } from '../change-order-owner-dialog/change-order-owner-dialog.component';
import { userInitials } from 'src/app/shared/utils/order-users-dedupe';
import { getUserColor } from 'src/app/shared/utils/user-color.util';
import { ILocationCodeTag, locationCodeTags } from 'src/app/shared/utils/location-codes.util';
import { HasPermissionDirective } from 'src/app/shared/has-permission.directive';
import { HasFieldVisibilityDirective } from 'src/app/shared/has-field-visibility.directive';

import { ITableColumnSetting, TablePreferencesService } from 'src/app/shared/table-preferences.service';
import { UI_PREFERENCE_KEYS, UiPreferencesService } from 'src/app/shared/ui-preferences.service';
import { TableColumnSettingsComponent } from 'src/app/ui/table-column-settings/table-column-settings.component';
import { CopyableComponent } from 'src/app/ui/copyable/copyable.component';
import { DetailFieldListComponent } from 'src/app/ui/detail-field-list/detail-field-list.component';
import {
  DetailFieldsSettingsComponent,
  IDetailFieldGroup,
  IDetailFieldGroupChange,
} from 'src/app/ui/detail-fields-settings/detail-fields-settings.component';
import { IDetailField, IDetailFieldChange } from 'src/app/ui/detail-field/detail-field.models';
import { OrderDetailFieldsService } from '../../services/order-detail-fields.service';
import { OrderAlertPreferencesService } from '../../services/order-alert-preferences.service';
import { FetchAllpaymentTerms } from 'src/app/features/customers/store/customers.actions';
import { selectHiddenFieldsForModule } from 'src/app/core/store/field-visibility/field-visibility.selectors';
import { ISegregationCheck, SegregationPreviewService } from '../../services/segregation-preview.service';
import {
  IProductCustomFieldCell,
  IProductCustomFieldColumn,
  ProductCustomFieldColumnKey,
  ProductCustomFieldColumnsService,
} from '../../services/product-custom-field-columns.service';
import { FtuePresenterService } from 'src/app/core/ftue/ftue-presenter.service';
import { FTUE_TIP_IDS } from 'src/app/core/ftue/ftue-tip.registry';
import { FTUE_ANCHORS, FtueAnchorKey } from 'src/app/core/ftue/ftue-anchors';
import {
  LineGroupView,
  LineGroupingController,
  LineGroupingMode,
  LineMatchGroup,
} from '../../utils/line-match-group.util';

type BaseDetailsColumnKey =
  | 'image'
  | 'product'
  | 'sku'
  | 'brand'
  | 'quantity'
  | 'quantity_preferred_selling_unit'
  | 'quantity_units'
  | 'msrp'
  | 'cost'
  | 'discount'
  | 'unit_price'
  | 'total_amount'
  | 'profit_margin'
  | 'delivery_date'
  | 'stock'
  | 'notes';

/** Hardcoded columns plus the product custom field columns added by WB-7619. */
type DetailsColumnKey = BaseDetailsColumnKey | ProductCustomFieldColumnKey;

interface IDetailsColumnConfig {
  label: string;
  /** Label shown in the column-visibility picker when it differs from the table header. */
  pickerLabel?: string;
  visible: boolean;
  sortable?: boolean;
  locked?: boolean;
  /** True when `label` is already a resolved string rather than an i18n key. */
  rawLabel?: boolean;
}

type SortDirection = 'asc' | 'desc';
type SortableDetailsColumnKey =
  | 'product'
  | 'sku'
  | 'brand'
  | 'quantity'
  | 'msrp'
  | 'cost'
  | 'unit_price'
  | 'total_amount'
  | 'profit_margin';

/** confirmAction() keys whose primary button pushes the order to the ERP. */
const APPROVE_ACTIONS = ['send_accepted_order', 'to_be_validated', 'pending_inventory'];

/** Mirrors the `validateOrder` action props so every ERP push can be routed through one helper. */
type IValidateOrderProps = {
  id: number;
  shouldDelete?: boolean;
  force?: boolean;
  forceSend?: boolean;
};

const DETAILS_QUOTES_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: ['DD/MM/YYYY', 'DD/MM/YY', 'YYYY-MM-DD'],
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-details-quotes',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    MatProgressSpinnerModule,
    ProductsQuoteFromCatalogComponent,
    ProductsQuoteFromAllProductsComponent,
    ButtonComponent,
    UiSvgIconComponent,
    UiIconComponent,
    ExploreCatalogComponent,
    QuotationsModule,
    StockFulfillmentComponent,
    ObjectCustomFieldsViewComponent,
    HasPermissionDirective,
    HasFieldVisibilityDirective,
    TableColumnSettingsComponent,
    EnrichCompanyEmailsCardComponent,
    CopyableComponent,
    DetailFieldListComponent,
    DetailFieldsSettingsComponent,
    MatMenuModule,
    LineCompositionPopoverComponent,
  ],
  templateUrl: './details-quotes.component.html',
  styleUrls: ['./details-quotes.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DETAILS_QUOTES_DATE_FORMATS }],
})
export class DetailsQuotesComponent implements OnInit, OnDestroy {
  private static readonly THIS_TABLE_KEY = 'order_lines_table-details_quotes';

  /**
   * Order-lines figure in the products header (WB-8066). Replaces the old
   * "N lines / N SKUs" pair — both numbers now live in the breakdown popover,
   * which is the same component the orders list uses.
   */
  orderLinesCount(quotation: IQuotationDetail): number {
    return resolveLineCount(quotation.line_composition, quotation);
  }

  /** Amber badge: needs review + unmatched. 0 hides the badge. */
  attentionCount(quotation: IQuotationDetail): number {
    return resolveAttentionCount(quotation.line_composition);
  }

  // Configurable column order. 'image' and 'product' are pinned to the front;
  // 'product' cannot be hidden (it also carries the always-visible alert/status
  // icons). The leading select cell and the Agent-portal commission cell are
  // fixed and never part of this set.
  // 'discount' is deliberately absent (WB-7903): it is no longer offered in the
  // column picker on either lines table. Its config, cells and helpers are left
  // in place so it can be listed again by adding the key back here.
  private static readonly DEFAULT_ORDER: DetailsColumnKey[] = [
    'image', 'product', 'sku', 'notes', 'brand', 'quantity',
    'quantity_preferred_selling_unit', 'quantity_units', 'msrp', 'cost',
    'unit_price', 'total_amount', 'profit_margin', 'delivery_date', 'stock',
  ];
  private static readonly PINNED_KEYS = new Set<DetailsColumnKey>(['image', 'product']);
  private static readonly NON_HIDEABLE_KEYS = new Set<DetailsColumnKey>([
    'product', 'quantity', 'unit_price', 'total_amount',
  ]);
  /** Pricing / metrics columns gated by the company "hide pricing columns" setting. */
  private static readonly PRICING_KEYS = new Set<DetailsColumnKey>([
    'msrp', 'cost', 'discount', 'unit_price', 'total_amount', 'profit_margin',
  ]);

  /**
   * Company-level default: when true, pricing columns are hidden BY DEFAULT and
   * become hideable (users can still re-enable them per-user — stored
   * preferences win).
   */
  private hidePricingColumns = false;

  /** Columns passed to the <ui-table-column-settings> popover. */
  pickerColumns: ITableColumnSetting[] = [];
  /** Current column order (configurable columns only). */
  columnOrder: DetailsColumnKey[] = [];

  /**
   * Product custom field columns (WB-7619) — appended after the hardcoded ones,
   * hidden by default, and looked up per cell by column key.
   */
  private customFieldColumns = new Map<ProductCustomFieldColumnKey, IProductCustomFieldColumn>();

  baseUrl = environment.BASE_URL_API;
  isNavaPress = this.baseUrl.includes('nava-press');
  DATE_FORMAT = DATE_FORMAT;
  quoteId!: number;
  isStatusOpened: boolean = false;
  isPaymentStatusOpened: boolean = false;
  quotation$: Observable<IQuotationDetail | undefined> = this.store.select(state => state.quotations.quotation);
  linesMetadata$: Observable<IPagination | null> = this.store.select(state => state.quotations.linesMetadata);
  linesLoading$: Observable<boolean> = this.store.select(state => state.quotations.linesLoading);
  linesMetadata: IPagination | null = null;
  linesLoading: boolean = false;
  /** See `quotationsState.linesLoadFailed`; disarms the background page chain. */
  linesLoadFailed: boolean = false;
  linesLoadFailed$: Observable<boolean> = this.store.select(state => state.quotations.linesLoadFailed);
  canEdit$: Observable<boolean> = this.store.select(selectCanDo('order', 'edit'));
  canEdit: boolean = false;
  canCreateKbReference$: Observable<boolean> = this.store.select(selectCanDo('knowledge_base', 'create'));
  canCreateKbReference: boolean = false;
  canDeleteOrder$: Observable<boolean> = this.store.select(selectCanDo('order', 'delete'));
  canDeleteOrder = false;
  private enrichDialogOpenedForOrder = false;

  // Set when a manual match changed the company; consumed by the
  // UpdateQuotationDetailsSuccess listener to open the email-enrichment modal.
  private pendingEmailEnrichCompanyId: number | null = null;
  // Matched company's email registry (lowercased, ERP + Volta). Shared
  // by the sender-row "saved" check icon and the inline enrich card.
  companyRegistryEmails: Set<string> = new Set<string>();
  companyRegistryLoaded: boolean = false;
  private registryLoadedForCompanyId: number | null = null;
  private registryLoadCallbacks: Array<() => void> = [];
  // Matched company's locations, offered as the Shipping Location scope in the
  // enrich card and post-match dialog (WB-7092).
  companyLocations: ILocation[] = [];
  private locationsLoadedForCompanyId: number | null = null;
  private companyLocationsLoaded = false;
  private locationLoadCallbacks: Array<() => void> = [];
  isPromptToOrderLoading$: Observable<boolean> = this.store.select(state => state.quotations.promptToOrderLoading);
  quotationSourceContent$: Observable<IQuotationSourceContent | undefined> = this.store.select(state => state.quotations.quotationSourceContent);
  fullHistory$ = this.store.select(state => state.quotations.fullHistory);
  historyLoading$ = this.store.select(state => state.quotations.historyLoading);
  dealsByLine$ = this.store.select(state => state.quotations.dealsByLine);
  orderDeals$ = this.store.select(state => state.quotations.orderDeals);
  private _orderDeals: { best_deal: any[]; best_free_shipping: any | null; best_buy_x_get_y: any | null; order_programs: any[] } | null = null;
  alertsByLine: { [orderLineId: string]: IOrderLineAlert[] } = {};
  hasAnyOpenAlerts = false;
  /**
   * Empty until the preference is read, so a line reads as fully alerting before
   * `ngOnInit` has run; the subscription then carries what this browser hides.
   */
  disabledAlertTypes: string[] = [];
  quotation: IQuotationDetail | undefined = undefined;
  viewMode: boolean = false;

  /**
   * The split proposal currently attached to this order, or null — feeds the
   * header's "Split applies" tag (WB-7938). Kept in component state rather than
   * read off a save response so dismissing the preview modal is not terminal:
   * the tag stays put and re-opens the same proposal on click.
   */
  segregationCheck: ISegregationCheck | null = null;

  /** Order + location + company the current `segregationCheck` was computed for. */
  private segregationCheckKey: string | null = null;

  readonly LINKED_ORDERS_INLINE_MAX = LINKED_ORDERS_INLINE_MAX;

  catalog$: Observable<ICatalog | null> = this.store.select(state => state.catalogs.catalog);
  catalog: ICatalog | null = null;
  isMarginOnCost: boolean = false;
  productsWithDeals: (IParseProduct & {
    hasDeal: boolean;
    dealMessage: {pricebook: string, message: string} | null;
    newFinalPrice: number;
    newTotalAmount: number;
    newProfit: number;
    newMarkup: number;
  })[] = [];
  subscriptions: Subscription[] = [];
  placeholder: string = 'assets/icones/default-image-product.svg';
  conflictPanelDismissed = false;
  /** True while a retry POST is in flight, so the button can't be double-clicked. */
  retryingErpSync = false;
  pendingForceSend = false;
  /** Armed when a send-to-ERP confirmation is validated with the sticky
   * "return to the order list" preference on; consumed once the flow resolves. */
  private pendingReturnToList = false;

  dismissConflictPanel() {
    this.conflictPanelDismissed = true;
  }

  /**
   * WB-7957/WB-8276: re-trigger the sync for an order Connect settled without
   * reaching the ERP. Only reachable from the error banner, which is itself
   * only shown for a settled-error `sync_status` (failed/canceled/not_applicable)
   * -- the backend re-validates that same guard and 409s otherwise (global
   * error toast handles that race).
   *
   * Patches the store directly with the response's fresh erp_sync block
   * (same no-refetch reducer the `erp_sync_status_changed` SSE event uses) so
   * the badge/banner update immediately without waiting for Connect's own
   * callback to round-trip.
   */
  retryErpSync(): void {
    if (this.retryingErpSync || !this.quoteId || !this.canEdit) return;
    this.retryingErpSync = true;
    this.services.retryErpSync(this.quoteId).subscribe({
      next: (res) => {
        this.retryingErpSync = false;
        const erpSync = res.object;
        if (erpSync) {
          this.store.dispatch(ErpSyncStatusChanged({
            id: this.quoteId,
            sync_status: erpSync.sync_status ?? 'pending',
            error_type: erpSync.error_type ?? null,
            error: erpSync.error ?? null,
            erp_message: erpSync.erp_message ?? null,
          }));
        }
      },
      error: () => {
        this.retryingErpSync = false;
      },
    });
  }

  userChipInitials = userInitials;
  getUserColor = getUserColor;

  toggleOwnershipHistory(): void {
    this.showOwnershipHistory = !this.showOwnershipHistory;
  }

  getLocationIdRoute(): number {
    return this.isLocationInformationMissing() ? this.quotation?.location.main_location_id! : this.quotation?.location.id!;
  }

  openChangeOwnerDialog(): void {
    const q = this.quotation;
    if (!q?.id) {
      return;
    }
    this.dialog
      .open(ChangeOrderOwnerDialogComponent, {
        width: '600px',
        maxWidth: '94vw',
        autoFocus: false,
        panelClass: 'change-owner-dialog-panel',
        data: { orderId: this.quoteId, currentOwner: q.owner },
      })
      .afterClosed()
      .subscribe((updated) => {
        if (updated) {
          this.refetchQuotationPreservingPagination();
        }
      });
  }

  private refetchQuotationPreservingPagination(): void {
    const loadedCount = this.quotation?.products?.length ?? 0;
    const limit = Math.max(loadedCount, DEFAULT_LINES_PAGE_SIZE);
    this.store.dispatch(GetQuotationById({ id: this.quoteId, paginate_lines: true, page: 1, limit, include_ai_details: false }));
  }

  loadMoreQuotationProducts(): void {
    if (this.linesLoading) return;
    if (!this.linesMetadata || this.linesMetadata.page >= this.linesMetadata.pages) return;
    this.store.dispatch(AppendQuotationPage({ id: this.quoteId }));
  }

  get hasMoreQuotationProducts(): boolean {
    return !!this.linesMetadata && this.linesMetadata.page < this.linesMetadata.pages;
  }

  onProductsScroll(event: Event): void {
    if (Date.now() < this.suppressScrollLoadUntil) return;
    const el = event.target as HTMLElement;
    const threshold = 120;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
    if (nearBottom) this.loadMoreQuotationProducts();
  }
  orderStatus: string[] = [
    'unfulfilled',
    'partially_fulfilled',
    'on_hold',
    'scheduled',
    'picked',
    'packed',
    'shipped',
    'processing',
    'in_transit',
    'pending',
    'started',
    'partial',
    'full',
    'canceled',
    'returned',
    'failed',
  ];

  paymentStatus: string[] = [
    "not paid",
    "in payment",
    "paid",
    "partial",
    "reversed"
  ];

  extractedNotes: { extracted: { category: string; text: string }[]; summary: string } | null = { extracted: [], summary: '' };
  currentAttachment: any[] = [];
  selectedAttachmentUrl: string = '';
  /** WB-7399: true once the user picked an attachment themselves — auto-selection never overrides that. */
  private userPickedAttachment = false;
  /** WB-7399: true once a resolved source document was previewed; stops a later line page flipping it. */
  private previewMatchLatched = false;
  /** Guards `maybeLoadFallbackSourceAttachments` against concurrent duplicate fetches only — NOT
   *  a "already tried this order" latch, so it can still retry after a later store emission wipes
   *  the borrowed attachments back out (e.g. a fresh, still-documentless fetch after Ask AI). */
  private fallbackAttachmentsFetchInFlight = false;
  /** Source order ids confirmed to have no attachments of their own, so a source that will never
   *  have documents isn't re-fetched on every subsequent `quotation`/`quotationSourceContent` emission. */
  private emptySourceAttachmentIds = new Set<number>();
  activeTab: string = 'details';
  shippingDate: string = '';
  partnerId: number | undefined = this.quotation?.location.id || undefined;
  id_company: number | undefined = this.quotation?.location.id_company || undefined;
  paymentTerms: IPayment_term | null = null;
  comment: string = '';
  validityDate: string = '';
  customerPoNumber: string = '';
  quoteIdValue: string = '';
  currentComponent: string = 'details';
  quoteProductsData!: IQuoteProductData;
  selectedProductsToAdd: IProduct[] = [];
  temporaryQuoteData: IQuoteProductData | null = null;
  hasQuoteChanges: boolean = false;
  isFormValid: boolean = false;
  initialIntent: number = 0;
  unmatchedProducts: IParseProduct[] = [];
  intent: number = 0;
  currency: ICurrency | null = null;
  insufficientInventory: IErpMissingInventory[] = [];
  missingProducts: IErpMissingProduct[] = [];
  productsQuote: IParseProduct[] = [];
  columns: Record<DetailsColumnKey, IDetailsColumnConfig> = {
    image: { label: 'quotations_and_orders.order_line_columns.image', visible: true, sortable: false },
    product: { label: 'quotations_and_orders.order_line_columns.product', visible: true, sortable: true, locked: true },
    sku: { label: 'quotations_and_orders.order_line_columns.sku', visible: true, sortable: true },
    brand: { label: 'quotations_and_orders.order_line_columns.brand', visible: true, sortable: true },
    quantity: { label: 'quotations_and_orders.order_line_columns.quantity', pickerLabel: 'quotations_and_orders.order_line_columns.quantity_picker', visible: true, sortable: true, locked: true },
    quantity_preferred_selling_unit: { label: 'quotations_and_orders.order_line_columns.quantity_preferred_selling_unit', pickerLabel: 'quotations_and_orders.order_line_columns.quantity_preferred_selling_unit_picker', visible: false, sortable: false },
    quantity_units: { label: 'quotations_and_orders.order_line_columns.quantity_units', pickerLabel: 'quotations_and_orders.order_line_columns.quantity_units_picker', visible: false, sortable: false },
    msrp: { label: 'quotations_and_orders.order_line_columns.msrp', visible: true, sortable: true },
    cost: { label: 'quotations_and_orders.order_line_columns.cost', visible: true, sortable: true },
    discount: { label: 'quotations_and_orders.order_line_columns.discount', visible: true, sortable: false },
    unit_price: { label: 'quotations_and_orders.order_line_columns.unit_price', visible: true, sortable: true, locked: true },
    total_amount: { label: 'quotations_and_orders.order_line_columns.total_amount', visible: true, sortable: true, locked: true },
    profit_margin: { label: 'quotations_and_orders.order_line_columns.profit_margin', visible: true, sortable: true },
    delivery_date: { label: 'quotations_and_orders.order_line_columns.delivery_date', visible: true, sortable: false },
    stock: { label: 'quotations_and_orders.order_line_columns.stock', visible: false, sortable: false },
    notes: { label: 'quotations_and_orders.order_line_columns.notes', visible: false, sortable: false },
  };
  activeSortColumn: SortableDetailsColumnKey | null = null;
  activeSortDirection: SortDirection = 'asc';
  selectedStockFulfillmentProduct: IParseProduct | null = null;
  isStockFulfillmentVisible: boolean = false;
  lastQuotationId: number = 0;
  currentFilter: IProduct[] = [];
  navigationHistory: string[] = [];
  avalableCurrencies: ICurrency[] = [];
  locationCurrency: ICurrency | null = null;
  quoteCurrency: ICurrency | null = null;
  disableCurrency: boolean = false;
  destroy$ = new Subject<void>();
  objectCustomField$: Observable<IObjectCustomFields | null> = this.store.select(state => state.settings.objectCustomFields);
  objectCustomFields: IObjectCustomFields | null = null;
  objectCustomFieldsParams: IObjectCustomFieldsParams = {
    object_type: RelatedObjectsTypes.ORDER,
    record_id: this.quoteId,
    visibility: [CustomFieldVisibilityTypes.BACKOFFICE],
    include_definitions: true,
  };
  currentLanguage: string = this.languageService.getCurrentLanguage();
  quotationSourceContent: IQuotationSourceContent | undefined = undefined;

  // ── Configurable detail blocks (WB-7463) ────────────────────────────────
  // Four `ui-detail-field-list` blocks replace the hand-written Customer,
  // Shipping, "Conditions" and Custom fields rows, all configured from a single
  // `ui-detail-fields-settings` drawer. The definitions live in
  // `OrderDetailFieldsService` so the side-by-side correction panel renders the
  // very same blocks against the very same stored preferences.
  /** Visible, ordered rows per block. */
  customerFields: IDetailField[] = [];
  shippingFields: IDetailField[] = [];
  orderReferenceFields: IDetailField[] = [];
  orderCustomFieldRows: IDetailField[] = [];

  /** Every block, with its full field list, as fed to the settings drawer. */
  fieldGroups: IDetailFieldGroup[] = [];

  /** The location's identifier codes, one tag per value. */
  taxCodeTags: ILocationCodeTag[] = [];

  /** Payment-term options backing the inline lookup on the customer block. */
  paymentTermOptions: IPayment_term[] = [];
  /** Order fields the current role hides; mirrors `*appFieldVisible` in TS. */
  private hiddenOrderFields: string[] = [];

  showOwnershipHistory = false;

  // Inline quantity editing state
  editingQuantityProductId: number | null = null;
  editQuantityHU: number = 0;
  editHandlingUnitId: number | null = null;
  /** Sentinel `mat-option` value that opens the create-selling-unit modal instead of selecting a unit. */
  readonly HU_CREATE_SENTINEL = '__create_selling_unit__';

  // Inline delivery date editing state
  editingDeliveryProductId: number | null = null;
  editDeliveryDate: Date | null = null;

  // Inline price editing state
  editingPriceProductId: number | null = null;
  editPriceValue: number = 0;

  // Add product search
  isAddProductMode = false;
  addProductQuery = '';
  searchProducts$: Observable<IProduct[]> = this.store.select((state: any) => state.products.productsBySearch);
  @ViewChild('addProductInput') addProductInput?: ElementRef<HTMLInputElement>;
  @ViewChild('addProductAutoTrigger', { read: MatAutocompleteTrigger }) addProductAutoTrigger?: MatAutocompleteTrigger;
  @ViewChild('productsTbody') productsTbody?: ElementRef<HTMLTableSectionElement>;
  @ViewChild('productsScrollContainer') productsScrollContainer?: ElementRef<HTMLDivElement>;
  private scrollToLastAfterAdd = false;
  private suppressScrollLoadUntil = 0;
  private pendingApplyAllRefetch = false;
  searchPage = 1;
  searchMetadata: IPagination | null = null;
  isLoadingMore = false;
  isSearchLoading = false;
  public getStatusTranslation(status: string): string {
    let currentStatus = status;
    if (status === 'QUOTATION_APPROVED') {
      if (this.quotation?.status === 'sale') {
        currentStatus = 'QUOTATION_ORDER_COMPLETED';
      } else if (this.quotation?.status === 'done') {
        currentStatus = 'QUOTATION_SENT_TO_ERP';
      }
    }
    return this.translateService.instant(`quotations_and_orders.QuotationHistoryStatus.${currentStatus}`) || currentStatus;
  }

  public getOrderStatus(status: string | undefined): string {
    return OrderStatusEnum[status as keyof typeof OrderStatusEnum] || status;
  }

  /** Anchor keys the template exposes to the FTUE framework (WB-7535). */
  readonly ftueAnchors = FTUE_ANCHORS;

  /** Memo behind `ftueAnchorFor`, keyed on the data the answer depends on. */
  private ftueAnchorCache?: {
    products: IParseProduct[];
    unmatched: IParseProduct[];
    sortColumn: SortableDetailsColumnKey | null;
    sortDirection: SortDirection;
    alternativesId: number | null;
    unmatchedId: number | null;
  };

  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private services: QuotesService,
    private translateService: TranslateService,
    private commonService: CommonService,
    private pricebookService: PricebookService,
    private languageService: LanguageService,
    public featureFlags: FeatureFlagService,
    private customerEmailService: CustomerEmailService,
    private customersService: CustomersService,
    private externalReferenceService: ExternalReferenceService,
    private exportService: QuotationExportService,
    private tablePrefs: TablePreferencesService,
    private productsService: ProductsService,
    private orderStatusDialog: OrderStatusDialogService,
    public productCode: ProductCodeService,
    private uiPrefs: UiPreferencesService,
    private segregationPreview: SegregationPreviewService,
    private productCustomFieldColumns: ProductCustomFieldColumnsService,
    private orderDetailFields: OrderDetailFieldsService,
    private priceCandidates: PriceCandidatesStore,
    private ftuePresenter: FtuePresenterService,
    private alertPreferences: OrderAlertPreferencesService,
  ) { }

  extractedShippingAddress(): string | undefined {
    return this.quotation?.ai_details?.extracted_info?.shipping?.raw_address;
  }

  ngOnInit(): void {
    this.priceCandidates.retain();
    this.initColumns();
    // Definitions arrive asynchronously, so the columns are hydrated again once
    // they land (and whenever the settings change under us).
    this.productCustomFieldColumns.columns$().pipe(takeUntil(this.destroy$)).subscribe((columns) => {
      this.syncCustomFieldColumns(columns);
      this.initColumns();
    });
    this.activatedRoute.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const newId = +params.get('id')!;
      if (this.quoteId && this.quoteId !== newId) {
        this.store.dispatch(clearQuotations());
        // The attachment selection belongs to ONE order — without this, order A's file stays
        // in B's preview.
        this.selectedAttachmentUrl = '';
        this.currentAttachment = [];
        this.userPickedAttachment = false;
        this.previewMatchLatched = false;
        this.unmatchedProducts = [];
      }
      this.quoteId = newId;
      this.objectCustomFieldsParams = { ...this.objectCustomFieldsParams, record_id: this.quoteId };
      // Opening the order clears its unread indicator, regardless of how it was
      // reached (list row, notification deep-link, or direct URL).
      this.store.dispatch(MarkQuotationRead({ id: this.quoteId }));
      this.store.dispatch(GetQuotationById({ id: this.quoteId, paginate_lines: true, page: 1, limit: DEFAULT_LINES_PAGE_SIZE, include_ai_details: false }));
      this.store.dispatch(SetCurrentElementId({ currentElementId: this.quoteId }));
      this.store.dispatch(GetQuotationSourceContent({ id: this.quoteId }));
      this.store.dispatch(GetObjectCustomFields({ params: this.objectCustomFieldsParams }));
    });
    this.linesMetadata$.pipe(takeUntil(this.destroy$)).subscribe((m) => {
      this.linesMetadata = m;
      this.maybeAutoLoadRemainingLines();
    });
    this.linesLoading$.pipe(takeUntil(this.destroy$)).subscribe((l) => {
      this.linesLoading = l;
      this.maybeAutoLoadRemainingLines();
    });
    this.linesLoadFailed$.pipe(takeUntil(this.destroy$)).subscribe((failed) => this.linesLoadFailed = failed);
    this.canEdit$.pipe(takeUntil(this.destroy$)).subscribe((canEdit) => this.canEdit = canEdit);
    this.canCreateKbReference$.pipe(takeUntil(this.destroy$)).subscribe((canCreate) => this.canCreateKbReference = canCreate);
    this.canDeleteOrder$.pipe(takeUntil(this.destroy$)).subscribe((canDelete) => this.canDeleteOrder = canDelete);
    // React to successful quotation field updates:
    //   1. Segregation preview — backend embeds segregation_check when N/A → company
    //      is first assigned and a mechanism applies; show the split modal immediately.
    //   2. Email enrichment — offer to add the sender email to the new company.
    this.actions$.pipe(
      ofType(UpdateQuotationDetailsSuccess),
      takeUntil(this.destroy$),
    ).subscribe((action) => {
      const segCheck = (action.changes as any)?.segregation_check;
      if (this.segregationPreview.isApplicable(segCheck)) {
        // Park it on the header tag too (WB-7938), so closing the modal without
        // splitting leaves a way back to the same proposal.
        this.segregationCheck = segCheck;
        // _openSegregationPreviewModal consumes pendingEmailEnrichCompanyId
        // and sequences the email-enrich dialog after the split modal closes.
        this._openSegregationPreviewModal(segCheck);
      } else if (this.pendingEmailEnrichCompanyId != null) {
        const companyId = this.pendingEmailEnrichCompanyId;
        this.pendingEmailEnrichCompanyId = null;
        this.openEnrichEmailsDialog(companyId);
      }
    });
    this.actions$.pipe(
      ofType(UpdateQuotationLinesSuccess),
      takeUntil(this.destroy$)
    ).subscribe((action) => {
      if (this.scrollToLastAfterAdd && action.delta.added && action.delta.added.length > 0) {
        this.scrollToLastAfterAdd = false;
        this.suppressScrollLoadUntil = Date.now() + 2000;
        setTimeout(() => {
          const el = this.productsScrollContainer?.nativeElement;
          if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
        });
      }
      if (this.pendingApplyAllRefetch) {
        this.pendingApplyAllRefetch = false;
        this.store.dispatch(GetQuotationById({ id: this.quoteId, paginate_lines: true, page: 1, limit: DEFAULT_LINES_PAGE_SIZE, include_ai_details: false }));
      }
    });
    const sub1 = this.quotation$.subscribe((quotation: IQuotationDetail | undefined) => {
        if (quotation && quotation.id !== this.quotation?.id) {
          this.enrichDialogOpenedForOrder = false;
        }
        if (quotation) {
          this.quotation = quotation
          // An order with no company matched is the one thing a new user cannot
          // guess their way out of. Fires at most once per user; the presenter
          // drops the request when it is not the first time.
          if (this.isCompanyInformationMissing()) {
            this.ftuePresenter.request(FTUE_TIP_IDS.ORDER_MISSING_COMPANY);
          }
          // Feature announcement: this table groups by match status (WB-8278).
          // Gated on an AI order with lines, because that is the only case where
          // grouping says anything — a hand-built order is entirely "matched", so
          // the grouped view is one header over the same list. The presenter owns
          // seen state, budget and cooldown, so requesting it on every qualifying
          // visit is correct, not wasteful. It ranks below the tips above, so an
          // order that also needs a decision teaches that first.
          if (this.isAiOrder() && (quotation.products?.length || 0) > 0) {
            this.ftuePresenter.request(FTUE_TIP_IDS.ORDER_LINE_GROUPING);
          }
          // Pricing-column visibility defaults from THIS order's own
          // creation-time snapshot (WB-7024), not the company's current
          // setting — so changing the company setting never retroactively
          // affects an order created under a different one.
          const hidePricingColumns = !!quotation.hide_pricing_columns;
          if (hidePricingColumns !== this.hidePricingColumns) {
            this.hidePricingColumns = hidePricingColumns;
            if (this.hidePricingColumns) {
              // One-time cleanup so this default takes effect even for users
              // whose stored prefs predate this setting (WB-6463) — see
              // TablePreferencesService.resetVisibilityOnce.
              this.tablePrefs.resetVisibilityOnce(
                DetailsQuotesComponent.THIS_TABLE_KEY,
                [...DetailsQuotesComponent.PRICING_KEYS],
                'wb6463_hide_pricing_columns_details_quotes'
              );
            }
            this.initColumns();
          }
          this.loadCompanyRegistry(quotation?.order_company?.id);
          this.loadCompanyLocations(quotation?.order_company?.id);
          this._syncSegregationApplicability(quotation);
          // WB-7957/WB-8276: a completed order stays out of view-mode when its
          // erp_sync settled into an error -- see canReopenCompletedOrderForErpSyncError.
          this.viewMode = (
            ['sale', 'done'].includes(quotation?.status ?? '') && !this.canReopenCompletedOrderForErpSyncError()
          ) || quotation.is_archived === true;
          this.conflictPanelDismissed = false;
          this.shippingDate = quotation?.shipping_date
          this.paymentTerms = quotation?.payment_terms
          this.comment = quotation?.comment
          this.validityDate = quotation?.validity_date
          this.customerPoNumber = quotation?.customer_po_number || ''
          this.quoteIdValue = quotation?.quote_id || ''
          this.buildDetailFields();
          if(quotation?.pricelist_id) {
            this.store.dispatch(ClearCatalog());
            this.store.dispatch(GetCatalogById({ id: quotation?.pricelist_id! }));
          }

          this.locationCurrency = quotation?.location?.currency || null;
          this.quoteCurrency = quotation?.currency || null;
          if (quotation?.location?.id && quotation?.pricelist_id) {
            this.store.dispatch(GetProductsCatalogCompanyById({ locationId: quotation?.location.id!, catalogId: quotation?.pricelist_id!, orderId: quotation?.id }));
            this.store.dispatch(SetCatalogLoader({ isLoading: false }));
          }

          this.maybeLoadFallbackSourceAttachments();
          this.loadPriceCandidates();
        }
        if(quotation?.ai_details){
          if (quotation?.id) {
            this.quoteId = quotation.id;
          }
          this.intent = quotation.ai_details.intent;
          this.initialIntent = quotation.ai_details.intent;
          this.unmatchedProducts = quotation.ai_details.unmatched_order_lines;
        }
        if(quotation?.currency){
          this.currency = quotation.currency;
        }
        if (quotation?.products && quotation.products.length > 0) {
          this.lastQuotationId = quotation.id;
          this.productsQuote = quotation.products.map((product) => ({
            ...product,
            stock_reservation: product.stock_reservation || [],
            quantity_handling_unit: product.customer_order_unit?.quantity ?? product.quantity_handling_unit,
          }));
          this.applyCurrentSort();
          if (quotation.products.length > 0) {
            this.disableCurrency = true;
          }
        } else if (quotation?.products) {
          // Order emptied (e.g. last line removed): clear local rows so no stale
          // product lingers in the table behind the empty state.
          this.productsQuote = [];
          this.selectedLineIds.clear();
          this.selectedUnmatchedIds.clear();
        }
        // WB-7399: the lines just landed — see the twin call in the source-content subscription.
        this.autoSelectPreviewAttachment();
        // Same moment, for the same reason: the line-matching tips can only be
        // judged once the rows exist.
        this.requestLineMatchingTips();
    });
    const sub2 = this.actions$.pipe(
      ofType(SendQuotationSuccess, cancelQuotationSuccess, validateOrderSuccess, AcceptQuotationSuccess, EditAndSendQuotationSuccess, EditQuotationSuccess, EditDraftQuotationSuccess, ResendQuotationSuccess, UpdateEmailOrderSuccess, UpdateAiNotesSuccess, DeleteDuplicateProductsSuccess, PromptToOrderSuccess),
        tap((action) => {
          if(action.type === PromptToOrderSuccess.type) {
            if(action.quotation.products.length === 0 && (action.quotation.ai_details ? action.quotation.ai_details.unmatched_order_lines.length === 0 : true)) {
              this.commonService.showToast(
                this.translateService.instant(`alerts.quotation.prompt_to_order.error`),
                'ERROR',
                {
                  duration: TOAST_DURATION,
                  variant: 'PROMPT_TO_ORDER_ERROR',
                  variantTitle: this.translateService.instant('quotations_and_orders.prompt.no_products_found'),
                }
              );
            } else {
              this.refetchQuotationPreservingPagination();
              this.store.dispatch(GetQuotationSourceContent({ id: this.quoteId }));
            }
          } else {
            this.refetchQuotationPreservingPagination();
          }
      })).subscribe();

    const sub3 = this.actions$.pipe(
      ofType(invoiceQuotationSuccess),
      tap(() => {
        this.refetchQuotationPreservingPagination();
      })).subscribe();

    const sub4 = this.actions$.pipe(
      ofType(validateOrderSuccess),
      tap((action: { quotation: ISentToErpRespone }) => {
        if (this.pendingForceSend) {
          this.pendingForceSend = false;
          this.returnToListIfRequested();
          return;
        }
        if(action.quotation.erp_missing_products && Array.isArray(action.quotation.erp_missing_products) && action.quotation.erp_missing_products.length > 0) {
          const allProductsMissing = this.quotation?.products.length === action.quotation.erp_missing_products.length;
          this.confirmAction('erp_missing_products', action.quotation.erp_missing_products, [], allProductsMissing);
        }
        else if(action.quotation.erp_missing_inventory && Array.isArray(action.quotation.erp_missing_inventory) && action.quotation.erp_missing_inventory.length > 0){
          this.confirmAction('erp_missing_inventory', [], action.quotation.erp_missing_inventory, false);
        }
        else if (this.shouldOfferPostSendEnrich) {
          // Order is safely in the ERP: suggest promoting the parsed codes into
          // customer external references for future orders (forward-looking, non-blocking).
          // The redirect, if requested, happens once that dialog is dismissed.
          this.openEnrichExternalReferencesDialog();
        }
        else {
          this.returnToListIfRequested();
        }
      })).subscribe();

    const sub5 = this.actions$.pipe(
      ofType(deleteQuotationSuccess),
      tap(() => {
        this.router.navigate(['/quotations'], {
          queryParamsHandling: 'merge',
        });
      })).subscribe();

    this.orderDeals$.pipe(takeUntil(this.destroy$)).subscribe(deals => this._orderDeals = deals);

    const sub6 = this.objectCustomField$.subscribe((objectCustomFields: IObjectCustomFields | null) => {
      if (objectCustomFields) {
        this.objectCustomFields = objectCustomFields;
        // Custom fields are one of the configurable blocks (WB-7463).
        this.buildDetailFields();
      }
    });

    // Payment terms back the inline lookup on the customer block; the list is
    // small and cached in the store, so one fetch on open is enough.
    this.store.dispatch(FetchAllpaymentTerms());
    this.store
      .select((state) => state.customers.allPaymentTerms)
      .pipe(takeUntil(this.destroy$))
      .subscribe((terms: IPayment_term[]) => {
        this.paymentTermOptions = terms ?? [];
        this.buildDetailFields();
      });

    // Role-level field visibility, read here rather than through
    // `*appFieldVisible` because the rows are now generated in TypeScript.
    this.store
      .select(selectHiddenFieldsForModule('order'))
      .pipe(takeUntil(this.destroy$))
      .subscribe((hidden: string[]) => {
        this.hiddenOrderFields = hidden ?? [];
        this.buildDetailFields();
      });

    const sub7 = this.catalog$.subscribe((catalog: ICatalog | null) => {
      this.catalog = catalog;
      // Detect if catalog uses margin_on_cost pricing rule
      this.isMarginOnCost = catalog?.overall_pricing_rule === 'margin_on_cost';
    });

    const sub8 = this.quotationSourceContent$.subscribe((content: IQuotationSourceContent | undefined) => {
      this.quotationSourceContent = content;
      if(content?.ai_details?.extracted_info?.notes) {
        this.extractedNotes = this.normalizeExtractedNotes(content?.ai_details.extracted_info?.notes)
      }
      // WB-7399: lines and attachments arrive on independent streams, so both call this. It reads
      // the fields (never the payload) and is idempotent, so either arrival order converges.
      this.autoSelectPreviewAttachment();
      this.maybeLoadFallbackSourceAttachments();
    });

    const sub9 = this.store.select((s: any) => s.products.searchMetadata).subscribe((meta: IPagination | null) => {
      this.searchMetadata = meta;
      this.isLoadingMore = false;
      this.isSearchLoading = false;
    });

    const sub10 = this.store.select(state => state.quotations.alertsByLine).subscribe(alerts => {
      this.alertsByLine = alerts;
    });
    const sub11 = this.store.select(state => state.quotations.hasAnyOpenAlerts).subscribe(v => {
      this.hasAnyOpenAlerts = v;
    });
    // Live, so a type switched off in Settings drops out of the lines already
    // rendered here — no reload, and no re-fetch of the order.
    const sub12 = this.alertPreferences.disabledTypes$.subscribe((types) => {
      this.disabledAlertTypes = types;
    });

    this.subscriptions.push(sub1, sub2, sub3, sub4, sub5, sub6, sub7, sub8, sub9, sub10, sub11, sub12);
  }

  private normalizeExtractedNotes(
    notes: any
  ): { extracted: { category: string; text: string }[]; summary: string } | null {
    if (!notes) return null;
    const extracted = (notes.extracted || []).map((item: any) =>
      typeof item === 'string' ? { category: '', text: item } : item
    );
    return { extracted, summary: notes.summary || '' };
  }

  isAiOrder(): boolean {
    return this.quotation?.channel === 'prompt' || this.quotation?.channel === 'email';
  }

  // --- Bulk line selection / removal (parity with the side-by-side panel) ---
  // Unlike the panel, deletion here is persisted immediately, so it is confirmed first.
  // Matched and unmatched lines live in separate id spaces (matched: order_line_id →
  // `remove`; unmatched: ai_details line id → `removeUnmatched`), so they are tracked
  // in two sets to avoid id collisions across the two kinds.
  selectedLineIds = new Set<number>();
  selectedUnmatchedIds = new Set<number>();

  get canBulkSelectLines(): boolean {
    return !this.viewMode && this.stillEditable();
  }

  /** Stable id used for an unmatched line in the `removeUnmatched` payload. */
  private unmatchedLineId(item: IParseProduct): number | null {
    const id = (item as any)._unmatchedLineId ?? item.id;
    return id != null ? id : null;
  }

  private get selectableMatchedLines(): Array<IParseProduct & { _isUnmatched?: boolean }> {
    return this.combinedLines.filter((l) => !l._isUnmatched && l.order_line_id != null);
  }

  private get selectableUnmatchedLines(): Array<IParseProduct & { _isUnmatched?: boolean }> {
    return this.combinedLines.filter((l) => l._isUnmatched && this.unmatchedLineId(l) != null);
  }

  get selectedLinesCount(): number {
    return this.selectedLineIds.size + this.selectedUnmatchedIds.size;
  }

  isLineSelectable(item: IParseProduct & { _isUnmatched?: boolean }): boolean {
    return item._isUnmatched ? this.unmatchedLineId(item) != null : item.order_line_id != null;
  }

  isLineSelected(item: IParseProduct & { _isUnmatched?: boolean }): boolean {
    if (item._isUnmatched) {
      const id = this.unmatchedLineId(item);
      return id != null && this.selectedUnmatchedIds.has(id);
    }
    return item.order_line_id != null && this.selectedLineIds.has(item.order_line_id);
  }

  toggleLine(item: IParseProduct & { _isUnmatched?: boolean }, checked: boolean): void {
    if (item._isUnmatched) {
      const id = this.unmatchedLineId(item);
      if (id == null) return;
      if (checked) this.selectedUnmatchedIds.add(id);
      else this.selectedUnmatchedIds.delete(id);
      return;
    }
    if (item.order_line_id == null) return;
    if (checked) this.selectedLineIds.add(item.order_line_id);
    else this.selectedLineIds.delete(item.order_line_id);
  }

  isAllLinesSelected(): boolean {
    const matched = this.selectableMatchedLines;
    const unmatched = this.selectableUnmatchedLines;
    if (matched.length + unmatched.length === 0) return false;
    return (
      matched.every((l) => this.selectedLineIds.has(l.order_line_id!)) &&
      unmatched.every((l) => this.selectedUnmatchedIds.has(this.unmatchedLineId(l)!))
    );
  }

  isPartialLinesSelected(): boolean {
    return this.selectedLinesCount > 0 && !this.isAllLinesSelected();
  }

  toggleAllLines(checked: boolean): void {
    this.selectedLineIds.clear();
    this.selectedUnmatchedIds.clear();
    if (checked) {
      this.selectableMatchedLines.forEach((l) => this.selectedLineIds.add(l.order_line_id!));
      this.selectableUnmatchedLines.forEach((l) => this.selectedUnmatchedIds.add(this.unmatchedLineId(l)!));
    }
  }

  removeSelectedLines(): void {
    const remove = Array.from(this.selectedLineIds);
    const removeUnmatched = Array.from(this.selectedUnmatchedIds);
    if (remove.length + removeUnmatched.length === 0) return;

    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        title: this.translateService.instant('quotations_and_orders.side_by_side_panel.remove_selected_title'),
        text: this.translateService.instant('quotations_and_orders.side_by_side_panel.remove_selected_message', { count: remove.length + removeUnmatched.length }),
        icon: '../../../assets/icones/low-warning-100X100.svg',
        confirm_text: this.translateService.instant('common.confirm'),
        confirm_class: 'btn-warning',
      },
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) return;
      const payload: IUpdateQuotationLinesPayload = {};
      if (remove.length) payload.remove = remove;
      if (removeUnmatched.length) payload.removeUnmatched = removeUnmatched;
      this.store.dispatch(UpdateQuotationLines({ id: this.quoteId, payload }));
      this.selectedLineIds.clear();
      this.selectedUnmatchedIds.clear();
    });
  }

  openSideBySideDialog(): void {
    this.dialog.open(SideBySideCorrectionPanelComponent, {
      data: { quotationId: this.quoteId, origin: 'order-details' },
      panelClass: ['side-panel-slide-in', 'side-panel-full'],
    })
  }

  isExpired(validityDate: string): boolean {
    if (!validityDate) return false;
    const today = new Date();
    const validity = new Date(validityDate);
    return validity.setHours(0,0,0,0) < new Date().setHours(0,0,0,0);
  }

  compareProducts(current: IQuotationDetail, parent: IQuotationDetail) {
    const addedProducts: IParseProduct[] = current.products.filter(product => !parent.products.some(p => p.id === product.id));
    const removedProducts: IParseProduct[] = parent.products.filter(product => !current.products.some(p => p.id === product.id));
    const changedQuantityProducts = current.products.map(cp => {
      const pp = parent.products.find(p => p.id === cp.id);
        if (pp && pp.quantity !== cp.quantity) {
          return { product: cp, previousQuantity: pp.quantity };
        }
        return null;
    }).filter(pp => pp !== null) as { product: IParseProduct, previousQuantity: number }[];
    const changedPriceProducts = current.products.map(cp => {
      const pp = parent.products.find(p => p.id === cp.id);
        if (pp && pp.discount !== cp.discount) {
          return { product: cp, previousPrice: pp.discount };
        }
        return null;
    }).filter(pp => pp !== null) as { product: IParseProduct, previousPrice: number }[];

    return { addedProducts, removedProducts, changedQuantityProducts, changedPriceProducts };
  }

  getDeals(): IPriceBookViewDTO[] {
    const gifts: IPriceBookViewDTO[] = [];
    const hasDeal = (deal: IPriceBookViewDTO) =>
      gifts.some(d => d.id === deal.id);

    const orderDeals = this._orderDeals;
    if (orderDeals) {
      if (orderDeals.best_deal?.length) {
        for (const deal of orderDeals.best_deal) {
          if (!hasDeal(deal)) gifts.push(deal);
        }
      }
      if (orderDeals.best_free_shipping && !hasDeal(orderDeals.best_free_shipping)) {
        gifts.push(orderDeals.best_free_shipping);
      }
    }

    return gifts;
  }

  getProductsLineTotalAmount(): number {
    return this.quotation?.amount_total ?? 0;
  }

  isColumnVisible(key: DetailsColumnKey): boolean {
    return !!this.columns?.[key]?.visible;
  }

  /**
   * Visible configurable columns in display order.
   *
   * WB-7903: 'discount' is no longer offered as a column (dropped from
   * DEFAULT_ORDER), so the AI-order guard that used to live here is gone with
   * it. Its config, cells and helpers are kept for when it is brought back.
   */
  get orderedColumns(): DetailsColumnKey[] {
    return this.columnOrder.filter((key) => this.isColumnVisible(key));
  }

  /** Hydrate column visibility + order from stored user preferences. */
  private initColumns(): void {
    // Keep the column-settings picker in step with the header, which renders
    // productCode.primaryLabelKey directly (WB-7419).
    this.columns.sku.label = this.productCode.primaryLabelKey;
    const stored = this.tablePrefs.applyPreferences(
      DetailsQuotesComponent.THIS_TABLE_KEY,
      this.buildDefaultColumnSettings()
    );
    stored.forEach((column) => this.applyVisibility(column));
    this.columnOrder = this.pinnedFirst(stored.map((column) => column.key as DetailsColumnKey));
    this.pickerColumns = this.buildPickerColumns(this.columnOrder);
  }

  /** Emitted by <ui-table-column-settings> on reorder / show / hide. */
  onColumnsChange(columns: ITableColumnSetting[]): void {
    // Only persist columns whose visibility actually changed here — columns
    // the user didn't touch (e.g. a pure reorder, or an untouched column
    // carried along in this emission) must keep falling through to the
    // computed default so a company-level setting change still applies later.
    const changedVisibility: Record<string, boolean> = {};
    columns.forEach((column) => {
      const key = column.key as DetailsColumnKey;
      const wasVisible = this.columns[key]?.visible;
      const nowVisible = column.hideable === false ? true : column.visible;
      if (wasVisible !== nowVisible) {
        changedVisibility[key] = nowVisible;
      }
      this.applyVisibility(column);
    });
    this.columnOrder = this.pinnedFirst(columns.map((column) => column.key as DetailsColumnKey));
    // Rebuild from the normalised order so the picker matches the table — e.g. a
    // re-shown 'image' returns to the front instead of landing after 'product'.
    this.pickerColumns = this.buildPickerColumns(this.columnOrder);
    this.tablePrefs.save(
      DetailsQuotesComponent.THIS_TABLE_KEY,
      this.columnOrder.map((key) => this.toColumnSetting(key)),
      changedVisibility
    );
  }

  private applyVisibility(column: ITableColumnSetting): void {
    const target = this.columns[column.key as DetailsColumnKey];
    if (target) target.visible = column.hideable === false ? true : column.visible;
  }

  /**
   * Register the current product custom field definitions as columns, dropping
   * any that no longer exist. New ones default to hidden (WB-7619).
   */
  private syncCustomFieldColumns(columns: IProductCustomFieldColumn[]): void {
    this.customFieldColumns.forEach((_, key) => {
      if (!columns.some((column) => column.key === key)) {
        delete this.columns[key];
      }
    });
    this.customFieldColumns = new Map(columns.map((column) => [column.key, column]));
    columns.forEach((column) => {
      const existing = this.columns[column.key];
      this.columns[column.key] = {
        label: column.label,
        rawLabel: true,
        visible: existing?.visible ?? false,
        sortable: false,
      };
    });
  }

  /** Column keys in table order: the hardcoded set, then the custom field ones. */
  private get allColumnKeys(): DetailsColumnKey[] {
    return [...DetailsQuotesComponent.DEFAULT_ORDER, ...this.customFieldColumns.keys()];
  }

  isCustomFieldColumn(key: DetailsColumnKey): boolean {
    return this.customFieldColumns.has(key as ProductCustomFieldColumnKey);
  }

  /** Header text for a custom field column — already resolved, not an i18n key. */
  customFieldColumnLabel(key: DetailsColumnKey): string {
    return this.customFieldColumns.get(key as ProductCustomFieldColumnKey)?.label ?? '';
  }

  /** Resolved cell content for a custom field column, or null when the column is unknown. */
  customFieldCell(item: IParseProduct, key: DetailsColumnKey): IProductCustomFieldCell | null {
    const column = this.customFieldColumns.get(key as ProductCustomFieldColumnKey);
    if (!column) return null;
    return this.productCustomFieldColumns.cell(column, item?.custom_fields);
  }

  private buildDefaultColumnSettings(): ITableColumnSetting[] {
    return this.allColumnKeys.map((key) => {
      const setting = this.toColumnSetting(key);
      // Company default only — applyPreferences still lets a stored user
      // preference override this, so users who chose to show them keep them.
      if (this.hidePricingColumns && DetailsQuotesComponent.PRICING_KEYS.has(key)) {
        setting.visible = false;
      }
      return setting;
    });
  }

  private buildPickerColumns(order: DetailsColumnKey[]): ITableColumnSetting[] {
    return order.map((key) => this.toColumnSetting(key));
  }

  /**
   * When the company "hide pricing columns" setting is on, pricing columns
   * become hideable even if normally locked, so users can manage them.
   */
  private isHideable(key: DetailsColumnKey): boolean {
    if (this.hidePricingColumns && DetailsQuotesComponent.PRICING_KEYS.has(key)) {
      return true;
    }
    return !DetailsQuotesComponent.NON_HIDEABLE_KEYS.has(key);
  }

  private toColumnSetting(key: DetailsColumnKey): ITableColumnSetting {
    // Custom field columns can disappear between two hydrations (definition
    // deleted in settings), so never assume the config is still registered.
    const config = this.columns[key] as IDetailsColumnConfig | undefined;
    return {
      key,
      label: config?.pickerLabel ?? config?.label ?? key,
      visible: !!config?.visible,
      pinned: DetailsQuotesComponent.PINNED_KEYS.has(key),
      hideable: this.isHideable(key),
    };
  }

  private pinnedFirst(keys: DetailsColumnKey[]): DetailsColumnKey[] {
    const canonical = DetailsQuotesComponent.DEFAULT_ORDER;
    // Pinned columns keep a fixed canonical order (e.g. image before product),
    // regardless of when they were toggled off/on.
    const pinned = keys
      .filter((key) => DetailsQuotesComponent.PINNED_KEYS.has(key))
      .sort((a, b) => canonical.indexOf(a) - canonical.indexOf(b));
    const rest = keys.filter((key) => !DetailsQuotesComponent.PINNED_KEYS.has(key));
    return [...pinned, ...rest];
  }

  onSortColumn(column: SortableDetailsColumnKey): void {
    if (this.activeSortColumn === column) {
      this.activeSortDirection = this.activeSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.activeSortColumn = column;
      this.activeSortDirection = 'asc';
    }
    this.applyCurrentSort();
  }

  setSortColumnDirection(column: SortableDetailsColumnKey, direction: SortDirection): void {
    if (this.activeSortColumn === column && this.activeSortDirection === direction) return;
    this.activeSortColumn = column;
    this.activeSortDirection = direction;
    this.applyCurrentSort();
  }

  isSortedBy(column: SortableDetailsColumnKey): boolean {
    return this.activeSortColumn === column;
  }

  getSortDirection(column: SortableDetailsColumnKey): SortDirection | null {
    if (!this.isSortedBy(column)) return null;
    return this.activeSortDirection;
  }

  get visibleTableColumnsCount(): number {
    const baseVisible = (Object.keys(this.columns) as DetailsColumnKey[]).filter((key) => this.columns[key].visible).length;
    const commission = this.quotation?.channel === 'Agent portal' ? 1 : 0;
    return baseVisible + commission;
  }

  private applyCurrentSort(): void {
    if (!this.activeSortColumn) return;
    this.productsQuote = [...this.productsQuote].sort((a, b) => this.compareProductsByColumn(a, b, this.activeSortColumn!, this.activeSortDirection));
  }

  // ---------------------------------------------------------------------------
  // WB-8278 — group lines by resolution status
  // ---------------------------------------------------------------------------

  /** Mode + collapse state + bucketing, shared with the side-by-side panel's product list. */
  readonly grouping = new LineGroupingController();

  get lineGroupingMode(): LineGroupingMode {
    return this.grouping.mode;
  }

  onLineGroupingModeChange(mode: LineGroupingMode): void {
    if (!this.grouping.setMode(mode)) return;
    // Lines are paginated; grouping a partially-loaded list hides rows that belong at the top.
    // Pull the rest in the background, leaving the default view's lazy scroll-loading alone.
    if (mode === 'resolution') this.maybeAutoLoadRemainingLines();
  }

  isLineGroupCollapsed(key: LineMatchGroup): boolean {
    return this.grouping.isCollapsed(key);
  }

  toggleLineGroup(key: LineMatchGroup): void {
    this.grouping.toggle(key);
  }

  get groupedLines(): LineGroupView[] {
    return this.grouping.groups(
      () => this.combinedLines,
      [
        this.productsQuote, this.productsQuote.length,
        this.unmatchedProducts, this.unmatchedProducts?.length ?? 0,
        // A column sort reorders `productsQuote` in place, so the reference alone would not
        // invalidate the cache and the groups would keep the pre-sort row order.
        this.activeSortColumn, this.activeSortDirection,
      ],
    );
  }

  trackByLineGroup = this.grouping.trackByGroup;

  /**
   * One page at a time, each chained off the previous page's completion via the lines
   * subscriptions. Bounded and idempotent: the `linesLoading` guard stops overlapping requests and
   * it self-stops once every page is in. No-op outside the grouped mode.
   */
  private maybeAutoLoadRemainingLines(): void {
    if (!this.grouping.isGrouped) return;
    // A failed page leaves `linesMetadata` untouched, so `hasMoreQuotationProducts` stays
    // true while the error flips `linesLoading` back to false — which is exactly the
    // transition this chain listens on. Without this guard the two would re-dispatch each
    // other forever against an endpoint that is already failing. The manual "Load more"
    // button is not gated, so a user-driven retry still works and clears the flag.
    if (this.linesLoadFailed) return;
    if (this.linesLoading) return;
    if (!this.hasMoreQuotationProducts) return;
    this.store.dispatch(AppendQuotationPage({ id: this.quoteId }));
  }

  get combinedLines(): Array<IParseProduct & { _isUnmatched?: boolean }> {
    if (this.activeSortColumn) {
      return [
        ...this.productsQuote,
        ...(this.unmatchedProducts || []).map(p => ({ ...p, _isUnmatched: true as const })),
      ];
    }
    const matched = this.productsQuote.map(p => ({ ...p, _isUnmatched: false as const }));
    const unmatched = (this.unmatchedProducts || []).map(p => ({ ...p, _isUnmatched: true as const }));
    return [...matched, ...unmatched].sort((a, b) => (a.sequence ?? 999999) - (b.sequence ?? 999999));
  }

  /**
   * A line Volta matched through an alternative rather than an exact code —
   * the state whose status icon reads "Review alternatives". Derived from
   * `getProductStatusIcon` rather than re-testing `has_alternatives`, so the
   * tip can never ring an icon that is showing something else.
   */
  private isAlternativesMatchLine(line: IParseProduct & { _isUnmatched?: boolean }): boolean {
    return !line._isUnmatched && this.isAiOrder() && this.getProductStatusIcon(line) === 'check-list-icon';
  }

  /**
   * The FTUE anchor this line carries, or `undefined` (WB-7535). Bound on the
   * status icon of a matched row and on the unmatched icon, so exactly one row
   * rings for each tip: an order routinely holds several lines in the same
   * state, and ringing every one is noise rather than guidance.
   *
   * O(1) per row against a memoised answer, because the template calls this for
   * every row on every change-detection pass.
   */
  ftueAnchorFor(line: IParseProduct & { _isUnmatched?: boolean }): FtueAnchorKey | undefined {
    const id = this.ftueLineId(line);
    if (id === null) {
      return undefined;
    }
    const anchored = this.ftueAnchoredLines();

    if (line._isUnmatched) {
      return id === anchored.unmatchedId ? FTUE_ANCHORS.ORDER_LINE_UNMATCHED : undefined;
    }
    return id === anchored.alternativesId ? FTUE_ANCHORS.ORDER_LINE_ALTERNATIVES : undefined;
  }

  /**
   * A row's stable identity across change-detection passes, since `combinedLines`
   * hands out fresh copies and the memo below can only recognise a row by value.
   *
   * An unmatched row uses the same id the selection checkboxes do, via
   * `isLineSelectable`, so a row is the same row to both features. A matched row
   * prefers `order_line_id` and falls back to `product_id` — the identity
   * `trackByProductFn` already relies on being unique per row — so a line that
   * arrives without a line id still gets its ring instead of silently losing it.
   */
  private ftueLineId(line: IParseProduct & { _isUnmatched?: boolean }): number | null {
    if (line._isUnmatched) {
      return this.unmatchedLineId(line);
    }
    return line.order_line_id ?? line.product_id ?? null;
  }

  /**
   * Which line carries each anchor, computed once per data change.
   *
   * Every write to `productsQuote` and `unmatchedProducts` in this component
   * replaces the array — there is no `push` or `splice` on either — so comparing
   * references is a sound cache key. The sort state is part of it because
   * clearing the active column reorders the table without replacing anything.
   *
   * Caching the *decision* and not the row list is deliberate. This used to be a
   * getter that cloned every row and scanned the clones twice on every
   * change-detection pass. Caching the list would have removed that too, but a
   * stale entry would then mean stale rows; a stale entry here can at worst ring
   * the wrong line until the next refetch.
   *
   * That leaves one assumption: a line's match state (`has_alternatives`,
   * `matched`, `added_manually`) changes only via a refetch, which replaces the
   * array. True today — matching a line goes through
   * `refetchQuotationPreservingPagination`.
   */
  private ftueAnchoredLines(): { alternativesId: number | null; unmatchedId: number | null } {
    const cached = this.ftueAnchorCache;
    if (
      cached &&
      cached.products === this.productsQuote &&
      cached.unmatched === this.unmatchedProducts &&
      cached.sortColumn === this.activeSortColumn &&
      cached.sortDirection === this.activeSortDirection
    ) {
      return cached;
    }

    let alternativesId: number | null = null;
    let unmatchedId: number | null = null;

    // One pass in display order, so each anchor lands on the topmost line the
    // user actually meets. A row with no stable id is skipped rather than
    // claiming the anchor, which would leave the tip pointing at nothing.
    for (const line of this.combinedLines) {
      const id = this.ftueLineId(line);
      if (id === null) {
        continue;
      }
      if (alternativesId === null && this.isAlternativesMatchLine(line)) {
        alternativesId = id;
      } else if (unmatchedId === null && line._isUnmatched) {
        unmatchedId = id;
      }
      if (alternativesId !== null && unmatchedId !== null) {
        break;
      }
    }

    this.ftueAnchorCache = {
      products: this.productsQuote,
      unmatched: this.unmatchedProducts,
      sortColumn: this.activeSortColumn,
      sortDirection: this.activeSortDirection,
      alternativesId,
      unmatchedId,
    };
    return this.ftueAnchorCache;
  }

  /**
   * The two line-matching lessons, requested once the lines have landed.
   * Deliberately ordered: `alternatives` outranks `unmatched` and is declared as
   * its prerequisite, so an order carrying both teaches "these are candidates,
   * compare them" first and leaves the other eligible for a later visit. The
   * presenter drops whichever request does not apply.
   */
  private requestLineMatchingTips(): void {
    const lines = this.combinedLines;
    if (lines.some((line) => this.isAlternativesMatchLine(line))) {
      this.ftuePresenter.request(FTUE_TIP_IDS.ORDER_LINE_ALTERNATIVES);
    }
    if (lines.some((line) => line._isUnmatched)) {
      this.ftuePresenter.request(FTUE_TIP_IDS.ORDER_LINE_UNMATCHED);
    }
  }

  private compareProductsByColumn(
    a: IParseProduct,
    b: IParseProduct,
    column: SortableDetailsColumnKey,
    direction: SortDirection
  ): number {
    const asc = direction === 'asc';
    const stringCompare = (left: string, right: string): number => left.localeCompare(right, undefined, { sensitivity: 'base' });
    const numberCompare = (left: number, right: number): number => left - right;
    const nullLast = (left: unknown, right: unknown): number | null => {
      const leftMissing = left === null || left === undefined || left === '';
      const rightMissing = right === null || right === undefined || right === '';
      if (leftMissing && rightMissing) return 0;
      if (leftMissing) return 1;
      if (rightMissing) return -1;
      return null;
    };

    let result = 0;
    switch (column) {
      case 'product': {
        const left = a.name ?? '';
        const right = b.name ?? '';
        result = stringCompare(left, right);
        break;
      }
      case 'sku': {
        const left = a.sku ?? '';
        const right = b.sku ?? '';
        result = stringCompare(left, right);
        break;
      }
      case 'brand': {
        const left = a.brand_name ?? '';
        const right = b.brand_name ?? '';
        result = stringCompare(left, right);
        break;
      }
      case 'quantity': {
        const left = Number(a.quantity ?? 0);
        const right = Number(b.quantity ?? 0);
        result = numberCompare(left, right);
        break;
      }
      case 'msrp': {
        const left = Number(a.price_unit ?? 0);
        const right = Number(b.price_unit ?? 0);
        result = numberCompare(left, right);
        break;
      }
      case 'cost': {
        const missingCheck = nullLast(a.cost, b.cost);
        if (missingCheck !== null) return asc ? missingCheck : -missingCheck;
        const left = Number(a.cost ?? 0);
        const right = Number(b.cost ?? 0);
        result = numberCompare(left, right);
        break;
      }
      case 'unit_price': {
        const left = Number(a.final_price ?? 0);
        const right = Number(b.final_price ?? 0);
        result = numberCompare(left, right);
        break;
      }
      case 'total_amount': {
        const left = Number(a.total ?? 0);
        const right = Number(b.total ?? 0);
        result = numberCompare(left, right);
        break;
      }
      case 'profit_margin': {
        const left = this.computeProfit(a);
        const right = this.computeProfit(b);
        result = numberCompare(left, right);
        break;
      }
      default:
        result = 0;
        break;
    }
    return asc ? result : -result;
  }

  private computeProfit(product: IParseProduct): number {
    const finalPrice = Number(product.final_price ?? 0);
    const cost = Number(product.cost ?? 0);
    const quantity = Number(product.quantity ?? 0);
    return (finalPrice - cost) * quantity;
  }

  getProductGifts(product: IParseProduct): IPriceBookViewDTO[] {
    const gifts: IPriceBookViewDTO[] = [];

    const hasDeal = (deal: IPriceBookViewDTO) =>
      gifts.some(d => d.id === deal.id);

    const shouldAddBuyXGetYDeal = (deal: IPriceBookViewDTO): boolean => {
      const existingDeal = gifts.find(d => d.id === deal.id);

      // If deal doesn't exist, add it
      if (!existingDeal) {
        return true;
      }

      // If deal exists but doesn't have is_applied_reward and the new one does, add it
      // This allows the same deal as both triggering and applied reward
      if (!existingDeal.is_applied_reward && deal.is_applied_reward) {
        return true;
      }

      // Otherwise, don't add (already exists with same or higher is_applied_reward status)
      return false;
    };

    const deals = product.best_deal as IPriceBookViewDTO[] | null;
    if (deals && deals.length > 0) {
      for (const deal of deals) {
        if (!hasDeal(deal)) {
          gifts.push(deal);
        }
      }
    }

    let buyXGetYDeal = product.best_buy_x_get_y as IPriceBookViewDTO[] | null;

    if (buyXGetYDeal && buyXGetYDeal.length > 0) {
      for (const deal of buyXGetYDeal) {
        // For buyXGetYDeal, allow the same deal as both triggering and applied reward
        if (shouldAddBuyXGetYDeal(deal)) {
          gifts.push(deal);
        }
      }
    }

    return gifts;
  }

  getProductAppliedDiscounts(product: IParseProduct): any[] {
    const gifts = this.getProductGifts(product);
    const applied_discounts = []

    if(product.discount) {
      applied_discounts.push({
        title: 'Catalog Discount',
        type: 'catalog',
        message: null,
        discount: product.discount as number,
      });
    }

    if(product.extra_discount) {
      applied_discounts.push({
        title: 'Agent Extra Discount',
        type: 'agent',
        message: null,
        discount: product.extra_discount as number,
      });
    }

    for (const gift of gifts) {
      if(gift.calculation_type === 'extra_discount_on_products' || gift.calculation_type === 'extra_discount_on_full_order' ||
        (gift.calculation_type === 'buy_x_get_y' && gift.product_reward_scope === 'product_at_a_discount' && gift.is_applied_reward) ||
        (gift.calculation_type === 'buy_x_get_y' && gift.product_reward_scope === 'more_of_the_same_product_with_an_extra_discount' && gift.is_applied_reward)) {
        const message = this.pricebookService.getRewardMessage(gift, product.amount_for_deal, product.quantity_for_deal);
        applied_discounts.push({
          title: message.pricebook,
          type: 'pricebook',
          message: message.message,
          discount: message.parameters.extra_discount as number,
        });

      }
    }

    return applied_discounts;
  }

  trackByProductFn(index: number, product: any): number {
    return product.product_id;
  }

  isCompanyInformationMissing(): boolean {
    const companyName = this.quotation?.order_company?.name?.trim();
    return !companyName || companyName === 'N/A';
  }

  isLocationInformationMissing(): boolean {
    const locationName = this.quotation?.location?.name?.trim();
    return !locationName || locationName === 'N/A';
  }

  shippingAutofillSource(): string | null | undefined {
    return this.quotation?.ai_details?.shipping_autofill_source;
  }

  shippingHintTooltip(): string {
    const src = this.shippingAutofillSource();
    if (src === 'multiple_locations') {
      return this.translateService.instant('quotations_and_orders.side_by_side_panel.details.shipping_autofill.multiple_locations');
    }
    if (src === 'no_locations') {
      return this.translateService.instant('quotations_and_orders.side_by_side_panel.details.shipping_autofill.no_locations');
    }
    // Any other source that still leaves the location missing (dismissed soft match,
    // the fallback sources, or no source at all) blocks the approve just the same, so
    // the "Missing" chip must explain itself rather than show an empty tooltip.
    if (this.isShippingLocationBlocking()) {
      return this.translateService.instant('quotations_and_orders.side_by_side_panel.details.shipping_autofill.blocked_action');
    }
    return '';
  }

  /**
   * Gates the approve buttons ONLY. Sending a quote ('draft' / 'requested') and
   * accepting one ('sent') never reach the ERP, so they must stay available while the
   * shipping location is still being sorted out.
   */
  isShippingLocationBlocking(): boolean {
    return this.isLocationInformationMissing() && !this.isSingleLocationSoftMatch();
  }

  approveBlockers(): string[] {
    const blockers: string[] = [];

    if (this.unmatchedLineCount > 0) {
      blockers.push(this.translateService.instant(
        'quotations_and_orders.approve_blocked.unmatched_lines',
        { count: this.unmatchedLineCount },
      ));
    } else if (!this.hasRealProducts) {
      blockers.push(this.translateService.instant('quotations_and_orders.approve_blocked.no_products'));
    }
    if (this.isShippingLocationBlocking()) {
      blockers.push(this.translateService.instant('quotations_and_orders.side_by_side_panel.details.shipping_autofill.blocked_action'));
    }
    return blockers;
  }

  isApproveBlocked(): boolean {
    return this.approveBlockers().length > 0;
  }

  /** Newline-joined so the tooltip lists one blocker per line (see `.approve-blocked-tooltip`). */
  approveBlockedTooltip(): string {
    return this.approveBlockers().join('\n');
  }

  /**
   * true when the AI extracted a shipping address it could not confidently
   * match and the buyer company has a single location the BO can confirm with one tap.
   */
  isSingleLocationSoftMatch(): boolean {
    return this.shippingAutofillSource() === 'single_location_soft_match'
      && this.isLocationInformationMissing()
      && !this.quotation?.ai_details?.suggested_shipping_location_dismiss;
  }

  suggestedShippingLocation() {
    return this.quotation?.ai_details?.suggested_shipping_location;
  }

  /**
   * Accept the single suggested shipping location. The inline "Accept suggested
   * location?" card is itself the confirmation, so this assigns it directly
   * (partner_id / id_company -> PATCH quotations/:id), no extra popup.
   */
  acceptSuggestedLocation(): void {
    const suggested = this.quotation?.ai_details?.suggested_shipping_location;
    if (!suggested?.id) return;
    this.partnerId = suggested.id;
    this.id_company = this.quotation?.order_company?.id;
    this.updateQuuote();
  }

  /**
   * Single entry point for every ERP push. When the order still carries an unvalidated
   * AI shipping suggestion, the suggestion is persisted first and the approve is chained
   * on the PATCH — otherwise the backend rejects the submission for a missing shipping
   * location. Every `validateOrder` dispatch in confirmAction() goes through here so no
   * branch can bypass the check.
   */
  private dispatchValidateOrder(props: IValidateOrderProps): void {
    if (!this.isSingleLocationSoftMatch()) {
      this.store.dispatch(validateOrder(props));
      return;
    }
    this.applySuggestedLocationThenValidate(props);
  }

  /**
   * Persist the suggested shipping location, then approve — sequenced, not
   * fire-and-forget: dispatching both at once races the PATCH and reproduces the very
   * rejection this guards against. A failed PATCH aborts the approve entirely.
   */
  private async applySuggestedLocationThenValidate(props: IValidateOrderProps): Promise<void> {
    const suggested = this.suggestedShippingLocation();
    if (!suggested?.id) {
      this.store.dispatch(validateOrder(props));
      return;
    }

    // Deliberately a narrow payload rather than updateQuuote(), which resends the whole
    // details form from component state and would rewrite unrelated fields on approve.
    this.store.dispatch(UpdateQuotationDetails({
      id: this.quoteId,
      payload: { partner_id: suggested.id, id_company: this.quotation?.order_company?.id },
    }));

    // Filtered on orderId: UpdateQuotationDetails is dispatched from several other
    // places in this component (updateQuuote(), editShippingAddress(), ...) with no
    // mutual exclusion, so an unfiltered take(1) here could resolve on an unrelated
    // concurrent request instead of the PATCH this method just dispatched.
    const action = await firstValueFrom(
      this.actions$.pipe(
        ofType(UpdateQuotationDetailsSuccess, UpdateQuotationDetailsError),
        filter((a) => a.orderId === this.quoteId),
        take(1),
      )
    );

    if (action.type === UpdateQuotationDetailsError.type) {
      // armReturnToList() already ran in the dialog callback; undo it so a failed
      // approve does not bounce the user back to the list.
      this.cancelReturnToList();
      return;
    }

    this.store.dispatch(validateOrder(props));
  }

  /**
   * Discard the AI suggested shipping location: persist the dismissal
   * (POST .../ai_details/location/dismiss), which flips the
   * suggested_shipping_location_dismiss flag and hides the suggestion.
   */
  discardSuggestedLocation(): void {
    if (!this.quoteId) return;
    this.store.dispatch(DismissSuggestedLocation({ id: this.quoteId }));
  }

  dismissDuplicateBadge(): void {
    this.store.dispatch(DismissDuplicateBadge({ id: this.quoteId }));
  }

  getStatusStyles(status: string): { [key: string]: string } {
    let bgColor: string;
    let textColor: string;

    switch (status) {
      case 'QUOTATION_ACCEPTED':
        bgColor = '#D4FAE6';
        textColor = '#529C7B';
        break;
      case 'QUOTATION_CANCELED':
        bgColor = '#FFD4D4';
        textColor = '#C80A0A';
        break;
      case 'QUOTATION_DECLINED':
        bgColor = '#FFD4D4';
        textColor = '#C80A0A';
        break;
      default:
        bgColor = '#E2E2E2';
        textColor = '#595959';
        break;
    }

    return {
      'background-color': bgColor,
      'color': textColor,
    };
  }

  getSameEventCoun(event: string, history: any[], index: number): number | null {
    let count = 1;
    for (let i = history.length - 1; i > index; i--) {
      if (history[i].event === event) {
        count++;
      }
    }
    return count > 1 ? count - 1 : null;
  }

  toggleStatusDropdown(type: string) {
    if (type === 'order') {
      this.isStatusOpened = !this.isStatusOpened;
      this.isPaymentStatusOpened = false;
    } else {
      this.isPaymentStatusOpened = !this.isPaymentStatusOpened;
      this.isStatusOpened = false;
    }
  }

  getBadgeClass(event: string): string {
    switch (event) {
      case 'QUOTATION_ACCEPTED':
        return 'badge-approved';
      case 'QUOTATION_SENT_TO_ERP':
        return 'badge-approved';
      case 'QUOTATION_APPROVED':
        return 'badge-approved';
      case 'QUOTATION_CANCELED':
        return 'badge-canceled';
      case 'QUOTATION_DECLINED':
        return 'badge-canceled';
      case 'QUOTATION_PENDING_INVENTORY':
        return 'badge-pending';
      default:
        return '';
    }
  }

  changeStatus(status: string, id: number) {
    const message = this.translateService.instant("quotations_and_orders.confirm_change_status", {
      status_type: "order status",
      new_status: `<span class='success'>${this.translateService.instant('quotations_and_orders.OrderShippingStatus.' + status)}</span>`
    });
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        title: this.translateService.instant("quotations_and_orders.confirm_status_update"),
        text: message,
        icon: '../../../assets/icones/succsess.svg',
        confirm_text: this.translateService.instant('common.confirm'),
        confirm_class: "btn-primary"
      }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.store.dispatch(UpdateOrderStatus({ id: id, status: status, parentId: this.quoteId }));
      }
    });
  }

  killingStockMessage(product: IParseProduct){
    const alerts = this.getAlertsForLine(product);
    const killingAlert = alerts.find(a => a.type === 'killing_stock' && a.state === 'open');
    if (product.is_owned && killingAlert) {
      const totalOpen = killingAlert.details?.total_open_quantity ?? 0;
      if (totalOpen > product.quantity) {
        return "insufficient_stock_combined_orders";
      } else if (totalOpen == product.quantity) {
        return "requested_quantity_exceeds_available_stock";
      }
    }
    return false;
  }

  changePaymentStatus(status: string, id: number) {
    const message = this.translateService.instant("quotations_and_orders.confirm_change_status", {
      status_type: "payment status",
      new_status: `<span class='success'>${this.translateService.instant('quotations_and_orders.PaymentStatus.' + status)}</span>`
    });
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        title: this.translateService.instant("quotations_and_orders.confirm_status_update"),
        text: message,
        icon: '../../../assets/icones/succsess.svg',
        confirm_text: this.translateService.instant('common.confirm'),
        confirm_class: "btn-primary"
      }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.store.dispatch(UpdatePaymentStatus({ id: id, status: getInternalPaymentStatus(status), parentId: this.quoteId }));

      }
    });
  }

  reject() {
    this.dialog.open(QuoteRejectComponent, {
      data: {},
      disableClose: true
    });
  };

  preview() {
    this.dialog.open(QuoteDocumentComponent, {
      data: this.quotation?.id,
      disableClose: true
    });
  };

  previewQuote(timeline: any) {
    if (timeline?.products) {
      this.dialog.open(PreviewQuoteComponent, {
        data: timeline,
        disableClose: true
      });
      return;
    }
    if (!timeline?.id) return;
    this.services.getQuotationById(timeline.id).pipe(take(1)).subscribe((res) => {
      if (res.object) {
        this.dialog.open(PreviewQuoteComponent, {
          data: res.object,
          disableClose: true
        });
      }
    });
  };

  showTab(tab: string): void {
    if (this.activeTab === tab) {
      return;
    }
    this.activeTab = tab;
  }

  setPage(page: string) {
    if (this.currentComponent !== page) {
      this.navigationHistory.push(this.currentComponent);
    }
    this.currentComponent = page;
  }

  backTo() {
    const target = this.navigationHistory.pop() || 'details';
    const confirmNeeded =
      (this.hasQuoteChanges && target === 'products') ||
      (target === 'source-content' && this.intent !== this.initialIntent);

    if (confirmNeeded) {
      const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
        data: {
          title: this.translateService.instant('quotations_and_orders.unsaved_changes_title'),
          text: this.translateService.instant('quotations_and_orders.unsaved_changes_confirm_message'),
          icon: '../../../assets/icones/low-warning-100X100.svg',
          confirm_text: this.translateService.instant('common.confirm'),
          confirm_class: "btn-warning"
        }
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) { this.currentComponent = target; }
      });
    } else { this.currentComponent = target; }
  }

  goTo(form: string): void {
    if (
      form === 'products' &&
      (this.currentComponent === 'products-from-catalog' ||
        this.currentComponent === 'products-from-all-products')
    ) {
      const selectedProducts = (this.selectedProductsToAdd || []).filter((p) => !p.disabled);

      if (selectedProducts.length > 0) {
        const newProducts: IParseProduct[] = selectedProducts.map((product) => ({
        id: product.id || 0,
          name: product.name,
          images: product.images,
          sales_price: product.sales_price,
          tags: product.tags ? product.tags.map((t: any) => t.name ?? t) : [],
          product_template_id: product.product_template_id,
          quantity: product.quantity || product.min_qte || 1,
          sku: product.sku,
          erp_id: product.erp_id,
          barcode: product.barcode,
          discount: product.discount || 0,
          price_unit: this.getSalePrice(product),
          final_price: product.final_price ? product.final_price : this.calculateFinalPrice(product, product.discount || 0),
          image: product.image,
          cost: this.getCurrencyCost(product) ?? product.cost,
          increment: product.increment,
          max_qte: product.max_qte,
          min_qte: product.min_qte,
          total: this.getSalePrice(product) * (product.min_qte || 1),
          is_owned: product.is_owned,
          brand: product.brand?.name,
          description: product.description,
          status: product.status,
          brand_id: product.brand_id,
          brand_name: product.brand?.name,
          categories: product.categories,
          category_id: product.category_id!,
          best_deal: product.best_deal,
          best_buy_x_get_y: product.best_buy_x_get_y,
          is_buy_x_get_y_line: product.is_buy_x_get_y_line,
        }));

        // If we have temporary data, use it as the base
        let baseProducts = this.temporaryQuoteData ? this.temporaryQuoteData.products : this.quoteProductsData.products;

        baseProducts = baseProducts.map(product => ({
          ...product,
          extra_discount: product.extra_discount || 0,
          stock: product.stock,
        }));

        const uniqueNewProducts = newProducts.filter(newProduct =>
          !baseProducts.some(existingProduct => existingProduct.id === newProduct.id)
        );

        // Update quoteProductsData with new products
        this.quoteProductsData = {
          ...this.quoteProductsData,
          products: [...baseProducts, ...uniqueNewProducts],
          currency: this.quoteProductsData.currency
        };

        // Clear temporary data after using it
        this.temporaryQuoteData = null;
        this.selectedProductsToAdd = [];
      }
    } else if (
      (form === 'products-from-catalog' || form === 'products-from-all-products') &&
      this.currentComponent === 'products'
    ) {
      // Store current state before switching to catalog view
      this.temporaryQuoteData = JSON.parse(JSON.stringify(this.quoteProductsData));
    }
    this.setPage(form);
  }

  goToCatalogProducts(catalog: ICatalog): void {
    this.store.dispatch(ClearCatalog());
    if (catalog.id) {
      this.store.dispatch(GetCatalogById({ id: catalog.id }));
    }

    this.avalableCurrencies = catalog.currencies || [];
    this.quoteProductsData = {
      products: this.quotation?.products ?? [],
      currency: this.quotation?.currency,
      pricelist_name: catalog.name,
      pricelist_id: catalog.id,
      quotation_id: this.quotation?.id!,
      source: this.quotation?.channel,
      location_id: this.quotation?.location.id!,
      customer_id: this.quotation?.location?.id_company ?? null,
      catalog_default_handling_unit: catalog.default_handling_unit ? {
        id: catalog.default_handling_unit.id,
        name: catalog.default_handling_unit.name
      } : undefined
    }
    this.setPage("products-from-catalog");
  }

  alertType(product: IParseProduct): string {
    if (product.quantity > product.stock!) return 'alert_div_danger';
    const alerts = this.getAlertsForLine(product);
    const killingAlert = alerts.find(a => a.type === 'killing_stock' && a.state === 'open');
    if (killingAlert) {
      const limit = killingAlert.details?.killing_stock_limit ?? 0;
      if (limit < 0 || product.quantity == product.stock!) return 'alert_div_warning';
    }
    return '';
  }

  alertMessage(product: IParseProduct): string {
    if (product.quantity > product.stock!) return 'quotations_and_orders.requested_quantity_exceeds_available_stock';
    const alerts = this.getAlertsForLine(product);
    const killingAlert = alerts.find(a => a.type === 'killing_stock' && a.state === 'open');
    if (killingAlert) {
      const limit = killingAlert.details?.killing_stock_limit ?? 0;
      if (limit < 0) return 'quotations_and_orders.insufficient_stock_combined_orders';
    }
    if (product.quantity == product.stock!) return 'quotations_and_orders.order_deplete_available_stock';
    return '';
  }

  alertQuantityRules(product: IParseProduct): string{
    if (product.quantity === undefined || product.quantity <= 0) {
      return 'quotations_and_orders.quantityInvalid';
    }

    if (product.min_qte !== undefined && product.min_qte !== null && product.quantity < product.min_qte) {
      return 'quotations_and_orders.quantityMinWarning';
    }

    if (product.max_qte !== undefined && product.max_qte !== null && product.quantity > product.max_qte) {
      return 'quotations_and_orders.quantityMaxWarning';
    }

    // Valid quantity = min_qte + (multiple of increment)
    const minQte = product.min_qte ?? 0;
    if (product.increment !== undefined && product.increment !== null && product.increment > 0) {
      const remainder = (product.quantity - minQte) % product.increment;
      if (remainder !== 0) {
        return 'quotations_and_orders.quantityIncrementWarning';
      }
    }

    return '';
}

hasAlerts(product: IParseProduct): boolean {
  return this.getEnabledAlertsForLine(product).some(alert => alert.state !== 'ignored');
}

getAlertsForLine(product: IParseProduct): IOrderLineAlert[] {
  return this.alertsByLine[String(product.order_line_id)] || [];
}

/**
 * What this browser is shown, which is what the alert icon, its dialog and the
 * stock fulfillment dialog stand for. The in-table `.alert_div` rows keep reading
 * `getAlertsForLine`: they are computed from the line's own quantity and stock,
 * not from the alerts feature this setting covers.
 */
getEnabledAlertsForLine(product: IParseProduct): IOrderLineAlert[] {
  return this.getAlertsForLine(product).filter(alert => !this.disabledAlertTypes.includes(alert.type));
}

handleAlerts(product: IParseProduct): void {
  const alerts = this.getEnabledAlertsForLine(product);
  const dialogRef = this.dialog.open(OrderLineAlertsComponent, {
    data: { product, alerts, baseUrl: this.baseUrl, quotationId: this.lastQuotationId },
    panelClass: 'order-line-alerts-dialog'
  });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      if (result.action === 'delete') {
        if (!product.order_line_id) return;
        this.store.dispatch(UpdateQuotationLines({ id: this.quoteId, payload: {
          remove: [product.order_line_id]
        }}));
      } else {
        this.showStockFulfillment(product);
      }
  });
}

  sourceContent() {
    this.setPage('source-content');
  }

  editQuote() {
    // Incase there is a promotion applied on the product level, we replace the final price with the new price after the promotion is applied on the backend side,
    // we need to revert it to the original final price when going to the edit quote products page.
    const restoreOriginalFinalPrices = this.quotation?.products?.map(product => ({
      ...product,
      final_price: product.old_final_price ?? product.final_price
    }));

    this.quoteProductsData = {
      products: restoreOriginalFinalPrices || [],
      pricelist_id: this.quotation?.pricelist_id!,
      quotation_id: this.quotation?.id!,
      location_id: this.quotation?.location.id!,
      customer_id: this.quotation?.location?.id_company ?? null,
      pricelist_name: this.quotation?.pricelist_name,
      source: this.quotation?.channel,
      currency: this.quotation?.currency,
      catalog_default_handling_unit: this.quoteProductsData?.catalog_default_handling_unit,
      all_lines_no_price: !!this.quotation?.all_lines_no_price
    }
    this.setPage('products');
  }

  exploreCatalog() {
    this.setPage('explore-catalog');
  }

  promptAiVolta() {
    this.dialog.open(PromptToOrderComponent, {
      data: {
        quotation_id: this.quotation?.id
      },
      disableClose: true
    }).afterClosed().subscribe((result: { unstructuredData: string, selectedFiles: IFile[] }) => {
      if (result) {
        this.store.dispatch(PromptToOrder({ id: this.quoteId, payload: {
          unstructured_data: result.unstructuredData,
          attachments: result.selectedFiles
        } }));
      }
    });
  }

  newQuote() {
    this.dialog.open(EditQuotesComponent, {
      data: {
        products: this.quotation?.products,
        pricelist_id: this.quotation?.pricelist_id,
        quotation_id: this.quotation?.id,
        location_id: this.quotation?.location.id,
        currency: this.quotation?.currency
      },
      disableClose: true
    })
  }

  get hasProducts(): boolean {
    const products = this.quotation?.products || [];
    return products.length > 0 || this.unmatchedProducts.length > 0;
  }

  /**
   * Matched order lines only. Unmatched AI lines have no product to send, so an order
   * carrying nothing else is rejected by the ERP — they must not count towards approve.
   */
  get hasRealProducts(): boolean {
    return (this.quotation?.products || []).length > 0;
  }

  get unmatchedLineCount(): number {
    return (this.unmatchedProducts || []).length;
  }

  /** Settled-error erp_sync states a completed order can still be fixed from (WB-7957/WB-8276). */
  private static readonly ERP_SYNC_ERROR_STATUSES = new Set(['failed', 'canceled', 'not_applicable']);

  /**
   * True for a 'sale'/'done' order whose async ERP sync settled into an error --
   * the one exception every completed-order edit lock in this component carves
   * out (stillEditable, the products-page entry button, canBulkSelectLines via
   * the `viewMode` field). The order itself is complete, but Connect never got
   * it onto the ERP, so the user needs a way back in to correct whatever it
   * rejected and retry -- not a hard lock that only a status this order will
   * never leave again could clear.
   */
  canReopenCompletedOrderForErpSyncError(): boolean {
    return (
      this.featureFlags.asyncErpSyncEnabled &&
      ['sale', 'done'].includes(this.quotation?.status!) &&
      DetailsQuotesComponent.ERP_SYNC_ERROR_STATUSES.has(this.quotation?.erp_sync?.sync_status ?? '')
    );
  }

  stillEditable(): boolean {
    if (this.quotation?.is_archived) return false;
    if (['draft', 'requested', 'sent', 'to_be_validated'].includes(this.quotation?.status!)) {
      return true;
    }
    return this.canReopenCompletedOrderForErpSyncError();
  }

  editCustomer() {
    const company = this.quotation?.order_company
      ? { id: this.quotation.order_company.id, name: this.quotation.order_company.name }
      : null;
    const location = this.quotation?.location ? { id: this.quotation?.location.id, name: this.quotation?.location.name } : null;
    const dialogRef = this.dialog.open(CompaniesSelectionDialogComponent, {
      data: { company: company, location: location, canGoBack: false, mode: 'edit', initialStep: 'company', order_id: this.quoteId, shipping_date: this.shippingDate }
    });

    dialogRef.afterClosed().subscribe((selected) => this.applyCustomerSelection(selected));
  }

  routingCompanyId(): number | null {
    if(this.quotation?.location?.is_different_company) {
      return this.quotation?.order_company?.main_location_id ?? null;
    } else {
      return this.quotation?.location?.id ?? null;
    }
  }

  addNewLocation(): void {
    const rawAddress = this.quotation?.ai_details?.extracted_info?.shipping?.raw_address;
    if (!rawAddress) return;

    const company = this.quotation?.order_company
      ? { id: this.quotation.order_company.id, name: this.quotation.order_company.name }
      : null;

    const dialogRef = this.dialog.open(CompaniesSelectionDialogComponent, {
      data: {
        company,
        initialStep: 'create',
        prefillLocation: {
          apartment: rawAddress,
        },
        mode: 'edit',
        order_id: this.quoteId,
        canGoBack: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.orderDetail) {
        this.store.dispatch(UpdateQuotationDetailsSuccess({ changes: result.orderDetail, orderId: result.orderDetail.id }));
      }
    });
  }

  /**
   * Handles the result of CompaniesSelectionDialogComponent (edit mode).
   * If a location was created inline (`orderDetail` present) the order is already
   * updated server-side, so just merge it; otherwise persist the selection.
   *
   * Segregation detection is handled by the backend: the PATCH endpoint returns
   * `segregation_check` when N/A → company is first assigned and a mechanism applies.
   * The `UpdateQuotationDetailsSuccess` subscriber reacts to that flag.
   */
  private applyCustomerSelection(selected: any): void {
    if (!selected) return;
    if (selected.orderDetail) {
      this.store.dispatch(UpdateQuotationDetailsSuccess({ changes: selected.orderDetail, orderId: selected.orderDetail.id }));
      return;
    }
    this._commitCustomerSelection(selected);
  }

  /**
   * WB-7938 — the header's "Split applies" tag re-opens the proposal, so
   * dismissing the modal is never terminal.
   */
  openSplitPreview(): void {
    if (this.segregationCheck) this._openSegregationPreviewModal(this.segregationCheck);
  }

  /**
   * Keeps the "Split applies" tag in step with the loaded order (WB-7938).
   *
   * Re-asks the backend whenever the order, its delivery location or its company
   * changes — the three inputs a splitting rule is matched on. That covers the
   * first load, so an order whose company was matched in an earlier session still
   * surfaces its proposal, and it clears a stale tag once a company change makes
   * the rule stop applying.
   *
   * Fire-and-forget: `checkApplicable` swallows errors into `null`, because the
   * tag is an affordance and must never block the page.
   */
  private _syncSegregationApplicability(quotation: IQuotationDetail): void {
    const orderId = quotation.id;
    const partnerId = quotation.location?.id;
    const companyId = quotation.order_company?.id;

    const key = `${orderId}|${partnerId ?? ''}|${companyId ?? ''}`;
    if (key === this.segregationCheckKey) return;
    this.segregationCheckKey = key;
    this.segregationCheck = null;

    // Only these two statuses can still be split — don't spend a request on the rest.
    const approvable = ['to_be_validated', 'pending_inventory'].includes(quotation.status ?? '');
    if (orderId == null || partnerId == null || !approvable) return;

    this.segregationPreview.checkApplicable(orderId, partnerId, companyId).pipe(
      takeUntil(this.destroy$),
    ).subscribe((check) => {
      // Drop a response that landed after the order moved on.
      if (this.segregationCheckKey === key) this.segregationCheck = check;
    });
  }

  /**
   * Open the segregation preview modal and execute split-in-place on confirm.
   *
   * The modal itself, the split call and its error toast live in
   * `SegregationPreviewService` (shared with the side-by-side panel, WB-7569).
   * What stays here is order-details-specific: the refetch shape and sequencing
   * the email-enrich dialog after the split modal closes.
   */
  private _openSegregationPreviewModal(preview: any): void {
    const orderId = this.quoteId;
    // Consume the pending email-enrich ID now so it's sequenced after the split modal.
    const pendingEnrichId = this.pendingEmailEnrichCompanyId;
    this.pendingEmailEnrichCompanyId = null;

    this.segregationPreview.openPreview(
      orderId,
      this.quotation?.name ?? `#${orderId}`,
      preview,
    ).subscribe((outcome) => {
      if (outcome === 'split') {
        // The proposal is spent; force the reloaded order to be re-evaluated.
        this.segregationCheck = null;
        this.segregationCheckKey = null;
        this.store.dispatch(GetQuotationById({
          id: orderId,
          paginate_lines: true,
          page: 1,
          limit: DEFAULT_LINES_PAGE_SIZE,
          include_ai_details: false,
        }));
      }
      if (pendingEnrichId != null) {
        this.openEnrichEmailsDialog(pendingEnrichId);
      }
    });
  }

  /** Persist the company/partner selection and dispatch the update action. */
  private _commitCustomerSelection(selected: any): void {
    this.partnerId = selected.location?.id;
    this.id_company = selected.company?.id;
    if (selected.shipping_date !== undefined) {
      this.shippingDate = selected.shipping_date ?? '';
    }
    const matchedCompanyId = selected.company?.id;
    const previousCompanyId = this.quotation?.order_company?.id;
    if (matchedCompanyId && matchedCompanyId !== previousCompanyId) {
      this.pendingEmailEnrichCompanyId = matchedCompanyId;
    }
    this.updateQuuote();
  }

  isCustomerEditable(): boolean {
    return this.quotation?.channel === 'email' && this.stillEditable();
  }

  /**
   * After a manual company match, offer to add the AI-parsed sender email to that
   * company's Email Registry so future orders auto-match. No-op when the user
   * lacks company-edit rights or no sender address was parsed.
   */
  private openEnrichEmailsDialog(companyId: number): void {
    if (!this.canEdit) return;
    const extractedEmails = this.getParsedEmails(this.quotationSourceContent);
    if (extractedEmails.length === 0) return;
    // Ensure the registry for the matched company is loaded first (it races the
    // match-success that triggers this dialog) so already-registered emails open
    // pre-toggled. Reuses the shared fetch — no extra request.
    this.loadCompanyRegistry(companyId, () => {
      this.loadCompanyLocations(companyId, () => {
        this.dialog.open(EnrichCompanyEmailsDialogComponent, {
          data: {
            customerId: companyId,
            companyName: this.quotation?.order_company?.name,
            emails: extractedEmails,
            registeredEmails: this.companyRegistryEmails,
            locations: this.companyLocations,
          },
        });
      });
    });
  }

  // ── Enrich external references ─────────────────────────────────────────────

  /** True when the order has a matched company and at least one semantically
   * matched line carrying a parsed code — the precondition for the enrich flow. The company must be
   * matched before any reference can be created — this is the defer-only guard. */
  get hasEnrichableCodes(): boolean {
    return !!this.quotation?.order_company?.id &&
      (this.productsQuote ?? []).some((line) => this.getSemanticParsedCodes(line).length > 0);
  }

  /** Only the automatic post-send suggestion is suppressed once the user opened ENRICH manually. */
  private get shouldOfferPostSendEnrich(): boolean {
    return !this.enrichDialogOpenedForOrder && this.hasEnrichableCodes && this.canCreateKbReference;
  }

  /** Opens the enrich dialog from the order-actions menu. */
  openEnrichFromMenu(): void {
    this.openEnrichExternalReferencesDialog();
  }

  /** One row per (code, matched product) aggregated across every hybrid_reranked line. */
  private buildEnrichCodeRows(): IEnrichCodeInput[] {
    return (this.productsQuote ?? []).flatMap((line) =>
      this.getSemanticParsedCodes(line).map((code) => ({
        code,
        sku: line.sku,
        productName: line.name,
      })),
    );
  }

  /** Pre-fetch the customer's saved references to compute already-saved keys, then
   * open the suggestion dialog. Fired from the order-actions menu or after a clean
   * ERP sync — purely forward-looking, so dismissing it changes nothing about the order. */
  private openEnrichExternalReferencesDialog(): void {
    const customerId = this.quotation?.order_company?.id;
    if (!customerId) {
      return;
    }
    this.enrichDialogOpenedForOrder = true;
    const quotationId = this.quotation?.id;
    const codes = this.buildEnrichCodeRows();
    const page: IPageCount = { number: 1, size: 1000 };
    this.externalReferenceService
      .listExternalReferences(page, '', {
        customer_id: customerId,
        source: '',
        product_id: null,
        create_date_from: null,
        create_date_to: null,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (this.quotation?.id !== quotationId) {
            return;
          }
          this.launchEnrichDialog(customerId, codes, this.buildSavedKeys(res?.data ?? []));
        },
        error: () => {
          if (this.quotation?.id !== quotationId) {
            return;
          }
          this.launchEnrichDialog(customerId, codes, new Set<string>());
        },
      });
  }

  /** Lowercased "sku|code" keys for the customer's existing references. */
  private buildSavedKeys(refs: IExternalReference[]): Set<string> {
    return new Set(refs.map((ref) => `${ref.sku}|${ref.reference_code}`.toLowerCase()));
  }

  private launchEnrichDialog(customerId: number, codes: IEnrichCodeInput[], savedKeys: Set<string>): void {
    this.dialog.open(EnrichExternalReferencesDialogComponent, {
      data: {
        customerId,
        companyName: this.quotation?.order_company?.name,
        codes,
        savedKeys,
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      // Only armed when this dialog followed a send-to-ERP confirmation; opening
      // it from the order-actions menu never redirects.
      .subscribe(() => this.returnToListIfRequested());
  }

  /** Extract the first email address from a raw header value (e.g. "Name <a@b.com>"). */
  private extractEmailAddress(raw: string | undefined | null): string | null {
    if (!raw) return null;
    const match = raw.match(/[^\s<>@]+@[^\s<>@]+\.[^\s<>@]+/);
    return match ? match[0].trim() : null;
  }

  /** Parsed sender address shown in the AI analysis tab. Normalized in case
   * original_sender ever arrives as a "Name <a@b.com>" header value. */
  getSenderEmail(content: IQuotationSourceContent | undefined | null): string | null {
    return this.extractEmailAddress(content?.ai_details?.extracted_info?.original_sender) ?? '';
  }

  /** All AI-extracted emails offered by the save-to-registry card: the original
   * sender plus every address in customer.emails, de-duplicated case-insensitively.
   * customer.emails is optional in the payload (legacy orders carry only the
   * singular email), so it is guarded. */
  getParsedEmails(content: IQuotationSourceContent | undefined | null): string[] {
    const sender = this.getSenderEmail(content);
    const extracted = content?.ai_details?.extracted_info?.customer?.emails?.map(e => e.email) ?? [];
    const candidates = [sender, ...extracted].map(e => e?.trim()).filter((e): e is string => !!e);
    return candidates.filter(
      (email, i) => candidates.findIndex(e => e.toLowerCase() === email.toLowerCase()) === i,
    );
  }

  /** Extracted emails other than the original sender — shown comma-separated in the
   * secondary row under the sender. */
  getOtherEmails(content: IQuotationSourceContent | undefined | null): string[] {
    const sender = (this.getSenderEmail(content) || '').toLowerCase();
    return this.getParsedEmails(content).filter(email => email.toLowerCase() !== sender);
  }

  /** True when an email is already in the matched company's registry. */
  isEmailInRegistry(email: string | null | undefined): boolean {
    return !!email && this.companyRegistryEmails.has(email.toLowerCase());
  }

  /** The enrich card saved an email. Company-scoped saves are added to the shared
   * registry set (new ref so the card re-evaluates) so the sender row's check icon
   * lights up; location-scoped saves stay local to the card (they don't belong in
   * the company registry). */
  onCompanyEmailSaved(event: IEnrichCardSavedEvent): void {
    if (event.locationId != null) return;
    const next = new Set(this.companyRegistryEmails);
    next.add(event.email.toLowerCase());
    this.companyRegistryEmails = next;
  }

  /** Load the matched company's email registry once per company so the sender row,
   * enrich card, and post-match dialog share a single source of truth. `onLoaded`
   * runs once the registry for `companyId` is available (immediately if already
   * loaded, or after the in-flight/started fetch resolves). */
  private loadCompanyRegistry(companyId: number | null | undefined, onLoaded?: () => void): void {
    if (!companyId) return;
    // Already loaded for this company → run the callback now.
    if (this.registryLoadedForCompanyId === companyId && this.companyRegistryLoaded) {
      onLoaded?.();
      return;
    }
    if (onLoaded) this.registryLoadCallbacks.push(onLoaded);
    // A fetch for this company is already in flight → just wait for it.
    if (this.registryLoadedForCompanyId === companyId) return;

    this.registryLoadedForCompanyId = companyId;
    this.companyRegistryLoaded = false;
    this.customerEmailService.list(companyId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (this.registryLoadedForCompanyId !== companyId) return; // superseded by a newer company
        this.companyRegistryEmails = new Set(
          (response?.data ?? [])
            .map((row) => (row.email ?? '').trim().toLowerCase())
            .filter(Boolean),
        );
        this.finishRegistryLoad();
      },
      // Fail open: a same-company duplicate is handled benignly on save (HTTP 409).
      error: () => {
        if (this.registryLoadedForCompanyId !== companyId) return;
        this.companyRegistryEmails = new Set<string>();
        this.finishRegistryLoad();
      },
    });
  }

  private finishRegistryLoad(): void {
    this.companyRegistryLoaded = true;
    const callbacks = this.registryLoadCallbacks;
    this.registryLoadCallbacks = [];
    callbacks.forEach((callback) => callback());
  }

  /** Load the matched company's locations once per company so the enrich card and
   * post-match dialog can offer them as a Shipping Location scope. `onLoaded` runs
   * once `companyLocations` actually reflects `companyId` — deferred until the
   * in-flight fetch resolves, never fired against a stale (previous-company) list.
   * Fails open to an empty list (the flows default to company-level). */
  private loadCompanyLocations(companyId: number | null | undefined, onLoaded?: () => void): void {
    if (!companyId) return;
    // Already resolved for this company → run the callback now.
    if (this.locationsLoadedForCompanyId === companyId && this.companyLocationsLoaded) {
      onLoaded?.();
      return;
    }
    if (onLoaded) this.locationLoadCallbacks.push(onLoaded);
    // A fetch for this company is already in flight → just wait for it.
    if (this.locationsLoadedForCompanyId === companyId) return;

    this.locationsLoadedForCompanyId = companyId;
    this.companyLocationsLoaded = false;
    // Clear immediately so the inline card (which binds companyLocations directly)
    // never shows the previous company's locations during the in-flight fetch.
    this.companyLocations = [];
    this.customersService.getCompanyById(companyId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (this.locationsLoadedForCompanyId !== companyId) return; // superseded by a newer company
        this.companyLocations = response?.object?.locations ?? [];
        this.finishLocationsLoad();
      },
      error: () => {
        if (this.locationsLoadedForCompanyId !== companyId) return;
        this.companyLocations = [];
        this.finishLocationsLoad();
      },
    });
  }

  private finishLocationsLoad(): void {
    this.companyLocationsLoaded = true;
    const callbacks = this.locationLoadCallbacks;
    this.locationLoadCallbacks = [];
    callbacks.forEach((callback) => callback());
  }

  /**
   * Sticky "return to the order list after confirmation" row of the send-to-ERP
   * confirmations. The choice is persisted as soon as it is toggled, so it is
   * remembered for the next order even if this dialog is cancelled.
   */
  private buildReturnToListCheckbox(): DialogCheckbox {
    return {
      label: this.translateService.instant('quotations_and_orders.status_dialog.return_to_list'),
      checked: this.uiPrefs.getFlag(UI_PREFERENCE_KEYS.RETURN_TO_LIST_AFTER_ORDER_CONFIRMATION),
      onToggle: (checked: boolean) =>
        this.uiPrefs.setFlag(UI_PREFERENCE_KEYS.RETURN_TO_LIST_AFTER_ORDER_CONFIRMATION, checked),
    };
  }

  /** Called when a send-to-ERP confirmation is validated: remember whether this
   * flow should end on the orders list. */
  private armReturnToList(): void {
    this.pendingReturnToList = this.uiPrefs.getFlag(
      UI_PREFERENCE_KEYS.RETURN_TO_LIST_AFTER_ORDER_CONFIRMATION
    );
  }

  /** The order never reached the ERP (user backed out / kept it pending), so we
   * stay on the detail page whatever the preference says. */
  private cancelReturnToList(): void {
    this.pendingReturnToList = false;
  }

  /**
   * Leave for the orders list once a send-to-ERP flow has fully resolved — i.e.
   * the order is in the ERP and no follow-up dialog is left to handle. Query
   * params are merged so the list keeps its filters and pagination.
   */
  private returnToListIfRequested(): void {
    if (!this.pendingReturnToList) {
      return;
    }
    this.pendingReturnToList = false;
    this.router.navigate(['/quotations'], { queryParamsHandling: 'merge' });
  }

  confirmAction(action: string, missingProducts?: IErpMissingProduct[], missingInventory?: IErpMissingInventory[], allProductsMissing?: boolean, productsValidated?: boolean) {

    // WB-7478: the approve / cancel / delete / duplicate / archive transitions are
    // now shared with the side-by-side correction panel, so their dialog config
    // lives in OrderStatusDialogService. Delegate and bail before the local switch;
    // only the quote-lifecycle cases ('draft' / 'requested' / 'sent' /
    // 'send_accepted_order') fall through — every case openSharedStatusDialog()
    // handles has an identically-named, unreachable case below. Edit the live
    // logic in OrderStatusDialogService / openSharedStatusDialog, not there.
    if (this.openSharedStatusDialog(action, productsValidated, missingProducts, missingInventory, allProductsMissing)) return;

    let title = '', description = '', misProducts: IErpMissingProduct[] = [], misInventory: IErpMissingInventory[] = [], erp_description = '', mainIcon = '', status: {
            from?: DialogStatus;
            to?: DialogStatus;
        } = {}, actions: DialogAction[] = [], checkbox: DialogCheckbox | undefined;

    switch (action) {
      case 'draft':
        title = this.translateService.instant('quotations_and_orders.status_dialog.send_quote.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.send_quote.description');
        status = {
          from: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.draft'),
            class: 'status-draft',
          },
          to: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.sent'),
            class: 'status-primary',
          },
        };
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.cancel'),
            class: 'action-danger',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.confirm'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.sendQuote();
              this.dialog.closeAll();
            },
          },
        ]
        break;
      case 'requested':
        title = this.translateService.instant('quotations_and_orders.status_dialog.send_quote.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.send_quote.description');
        status = {
          from: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.requested'),
            class: 'status-primary',
          },
          to: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.sent'),
            class: 'status-primary',
          },
        };
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.cancel'),
            class: 'action-danger',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.confirm'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.sendQuote();
              this.dialog.closeAll();
            },
          },
        ]
        break;
      case 'sent' :
        title = this.translateService.instant('quotations_and_orders.status_dialog.accept_order.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.accept_order.description');
        status = {
          from: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.sent'),
            class: 'status-primary',
          },
          to: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.to_be_validated'),
            class: 'status-primary',
          },
        };
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.cancel'),
            class: 'action-danger',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.accept_order'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.accept();
              this.dialog.closeAll();
            },
          },
        ]
        break;
      case 'send_accepted_order':
        title = this.translateService.instant('quotations_and_orders.status_dialog.send_accept_order.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.send_accept_order.description');
        status = {
          from: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.' + this.quotation?.status),
            class: this.quotation?.status === 'draft' ? 'status-draft' : 'status-primary',
          },
          to: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.done'),
            class: 'status-success',
          },
        };
        checkbox = this.buildReturnToListCheckbox();
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.cancel'),
            class: 'action-danger',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.approve_order'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.armReturnToList();
              if (this.isNavaPress && !productsValidated){
                this.checkQuotationAvailability();
              }else{
                this.dispatchValidateOrder({ id: this.quoteId });
              }
              this.dialog.closeAll();
            },
          },
        ]
        break;
      // `to_be_validated` / `pending_inventory` are handled by
      // `openSharedStatusDialog` above (WB-7478 / WB-7485): it returns true, so
      // confirmAction() never falls through to this switch for them.

      case 'erp_missing_products':
        title = this.translateService.instant('quotations_and_orders.status_dialog.erp_missing_products.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.erp_missing_products.description');
        status = {
          from: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.to_be_validated'),
            class: 'status-primary',
          },
          to: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.pending_inventory'),
            class: 'status-pending',
          },
        };
        misProducts = missingProducts || [];
        erp_description = this.translateService.instant('quotations_and_orders.status_dialog.erp_missing_products.erp_description');
        actions = [
          ...(allProductsMissing ? [] : [{
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.remove_products'),
            class: 'action-danger',
            icon: {
              position: 'before' as const,
              name: 'assets/icones/cancel_icon.svg'
            },
            callback: () => {
              this.dispatchValidateOrder({ id: this.quoteId, shouldDelete: true });
              this.dialog.closeAll();
            },
          }]),
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.ok'),
            class: 'action-primary',
            callback: () => {
              // Order stays out of the ERP: keep the user on the detail page.
              this.cancelReturnToList();
              this.dialog.closeAll();
            },
          },
        ]
        break;
      case 'erp_missing_inventory':
        title = this.translateService.instant('quotations_and_orders.status_dialog.erp_missing_inventory.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.erp_missing_inventory.description');
        status = {
          from: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.to_be_validated'),
            class: 'status-primary',
          },
          to: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.pending_inventory'),
            class: 'status-pending',
          },
        };
        misInventory = missingInventory || [];
        erp_description = this.translateService.instant('quotations_and_orders.status_dialog.erp_missing_inventory.erp_description');
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.keep_pending'),
            class: 'action-light',
            icon: {
              position: 'after',
              name: 'assets/icones/time_icon.svg'
            },
            callback: () => {
              // Order stays pending instead of reaching the ERP: no redirect.
              this.cancelReturnToList();
              this.dialog.closeAll();
            },
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.force_approve'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.dispatchValidateOrder({ id: this.quoteId, force: true });
              this.dialog.closeAll();
            },
          },
        ]
        break;

      case 'force_send_conflict':
        title = this.translateService.instant('quotations_and_orders.status_dialog.force_send_conflict.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.force_send_conflict.description');
        status = {
          from: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.to_be_validated'),
            class: 'status-primary',
          },
          to: {
            text: this.translateService.instant('quotations_and_orders.QuotationStatus.done'),
            class: 'status-success',
          },
        };
        misInventory = this.quotation?.erp_missing_inventory || [];
        erp_description = this.translateService.instant('quotations_and_orders.status_dialog.force_send_conflict.erp_description');
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.cancel'),
            class: 'action-danger',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.keep_original_date'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.dispatchValidateOrder({ id: this.quoteId, forceSend: true });
              this.dialog.closeAll();
            },
          },
        ]
        break;

      case 'cancel':
        title = this.translateService.instant('quotations_and_orders.status_dialog.cancel_order.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.cancel_order.description');
        mainIcon = 'assets/icones/main_cancel_icon.svg';
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.go_back'),
            class: 'action-light',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.cancel_order'),
            class: 'action-cancel',
            icon: {
              position: 'before',
              name: 'assets/icones/cancel_icon_white.svg'
            },
            callback: () => {
              this.cancel(this.quoteId);
              this.dialog.closeAll();
            },
          }
        ]
        break;
      case 'delete_order':
        title = this.translateService.instant('quotations_and_orders.status_dialog.delete_order.title');
        description = this.translateService.instant('quotations_and_orders.status_dialog.delete_order.description');
        mainIcon = 'assets/icones/main_delete_icon.svg';
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.go_back'),
            class: 'action-light',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.delete_order'),
            class: 'action-cancel',
            icon: {
              position: 'before',
              name: 'assets/icones/cancel_icon_white.svg'
            },
            callback: () => {
              this.deleteQuote(this.quoteId);
              this.dialog.closeAll();
            },
          }
        ]
        break;
      case 'duplicate_order':
        title = this.translateService.instant('quotations_and_orders.confirm.duplicate_title');
        description = this.translateService.instant('quotations_and_orders.confirm.duplicate_body', { name: this.quotation?.name ?? '' });
        mainIcon = 'assets/icones/copy.svg';
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.go_back'),
            class: 'action-light',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.actions.duplicate'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.duplicateQuote(this.quoteId);
              this.dialog.closeAll();
            },
          }
        ]
        break;
      case 'archive_order':
        title = this.translateService.instant('quotations_and_orders.confirm.archive_title');
        description = this.translateService.instant('quotations_and_orders.confirm.archive_body', { name: this.quotation?.name ?? '' });
        mainIcon = 'assets/icones/archive.svg';
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.go_back'),
            class: 'action-light',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.actions.archive'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.archiveQuote(this.quoteId, this.quotation?.name);
              this.dialog.closeAll();
            },
          }
        ]
        break;
      case 'unarchive_order':
        title = this.translateService.instant('quotations_and_orders.confirm.unarchive_title');
        description = this.translateService.instant('quotations_and_orders.confirm.unarchive_body', { name: this.quotation?.name ?? '' });
        mainIcon = 'assets/icones/unarchive.svg';
        actions = [
          {
            label: this.translateService.instant('quotations_and_orders.status_dialog.actions.go_back'),
            class: 'action-light',
            callback: () => this.dialog.closeAll(),
          },
          {
            label: this.translateService.instant('quotations_and_orders.actions.unarchive'),
            class: 'action-primary',
            icon: {
              position: 'after',
              name: 'arrow_forward'
            },
            callback: () => {
              this.unarchiveQuote(this.quoteId);
              this.dialog.closeAll();
            },
          }
        ]
        break;
      default:
        break;
    }
    // Warn that confirming will also validate the pending AI shipping suggestion.
    // Scoped to the approve-style dialogs so the missing-products / missing-inventory
    // follow-ups stay focused on their own decision.
    const warning = APPROVE_ACTIONS.includes(action) && this.isSingleLocationSoftMatch()
      ? this.translateService.instant('quotations_and_orders.soft_match.approve_validates_suggestion')
      : undefined;

    this.dialog.open(OrderStatusConfirmComponent, {
      data: {
        title,
        description,
        misProducts,
        misInventory,
        mainIcon,
        status,
        actions,
        erp_description,
        warning,
        checkbox,
      },
    });

  }

  /**
   * Opens the transitions that `OrderStatusDialogService` owns (shared with the
   * side-by-side panel). Returns `true` when the action was handled so
   * `confirmAction` can return early.
   */
  private openSharedStatusDialog(
    action: string,
    productsValidated?: boolean,
    missingProducts?: IErpMissingProduct[],
    missingInventory?: IErpMissingInventory[],
    allProductsMissing?: boolean,
  ): boolean {
    switch (action) {
      case 'erp_missing_products':
        this.orderStatusDialog.openErpMissingProducts({
          missingProducts: missingProducts ?? [],
          allProductsMissing: !!allProductsMissing,
          onRemoveProducts: () => this.dispatchValidateOrder({ id: this.quoteId, shouldDelete: true }),
        });
        return true;
      case 'erp_missing_inventory':
        this.orderStatusDialog.openErpMissingInventory({
          missingInventory: missingInventory ?? [],
          onForceApprove: () => this.dispatchValidateOrder({ id: this.quoteId, force: true }),
        });
        return true;
      case 'force_send_conflict':
        this.orderStatusDialog.openForceSendConflict({
          missingInventory: this.quotation?.erp_missing_inventory || [],
          onKeepOriginalDate: () => this.dispatchValidateOrder({ id: this.quoteId, forceSend: true }),
        });
        return true;
      case 'to_be_validated':
      case 'pending_inventory':
        // WB-7485: this is the live approve path — openSharedStatusDialog() returns true
        // above, so confirmAction() never falls through to the local switch's
        // (unreachable) 'to_be_validated' / 'pending_inventory' cases below.
        this.orderStatusDialog.openApproveOrder({
          fromStatus: action,
          checkbox: this.buildReturnToListCheckbox(),
          onConfirm: () => {
            this.armReturnToList();
            // Nava tenants re-check inventory before the order can be approved.
            if (this.isNavaPress && !productsValidated) {
              this.checkQuotationAvailability();
              return;
            }
            this.dispatchValidateOrder({ id: this.quoteId });
          },
        });
        return true;
      case 'cancel':
        this.orderStatusDialog.openCancelOrder({ onConfirm: () => this.cancel(this.quoteId) });
        return true;
      case 'delete_order':
        this.orderStatusDialog.openDeleteOrder({ onConfirm: () => this.deleteQuote(this.quoteId) });
        return true;
      case 'duplicate_order':
        this.orderStatusDialog.openDuplicateOrder({
          name: this.quotation?.name,
          onConfirm: () => this.duplicateQuote(this.quoteId),
        });
        return true;
      case 'archive_order':
        this.orderStatusDialog.openArchiveOrder({
          name: this.quotation?.name,
          onConfirm: () => this.archiveQuote(this.quoteId, this.quotation?.name),
        });
        return true;
      case 'unarchive_order':
        this.orderStatusDialog.openUnarchiveOrder({
          name: this.quotation?.name,
          onConfirm: () => this.unarchiveQuote(this.quoteId),
        });
        return true;
      default:
        return false;
    }
  }

  async checkQuotationAvailability() {
    if (!this.quotation) return;

    this.store.dispatch(
      CheckProductsAvailability({
        data: { quotation_id: this.quoteId, delivery_date: this.shippingDate },
      })
    );

    try {
      const action = await firstValueFrom(
        this.actions$.pipe(
          ofType(CheckProductsAvailabilitySuccess, CheckProductsAvailabilityError),
          take(1)
        )
      );

      if (action.type === CheckProductsAvailabilitySuccess.type) {
        this.missingProducts = action.data.missing_products;
        this.insufficientInventory = action.data.insufficient_inventory;
        if (action.data.accepted) {
          this.confirmAction('to_be_validated', [], [], false, true);
        } else {
          this.dialog.open(ProductsAvailabilityDialogComponent, {
            data: {
              missingProducts: this.missingProducts,
              insufficientInventory: this.insufficientInventory,
              acceptedDate: this.shippingDate,
            },
            disableClose: true,
          }).afterClosed().subscribe(result => {
            if (!result) {
              this.cancelReturnToList();
              return;
            }

            if (result?.keepOriginal) {
              this.pendingForceSend = true;
              this.dispatchValidateOrder({ id: this.quoteId, forceSend: true });
              return;
            }

            if (result?.remove) {
              const payload: IAskForQuotation = {
                pricelist_id: this.quotation?.pricelist_id!,
                is_final: false,
                products: this.productsQuote.map(product => ({
                  product_id: product.id,
                  name: product.name,
                  quantity: product.quantity,
                  discount: product.discount,
                  increment: product.increment,
                  min_qte: product.min_qte,
                  max_qte: product.max_qte,
                  sku: product.sku,
                  price_unit: product.price_unit,
                  final_price: product.final_price,
                  total_discount: product.discount
                })).filter(product => !this.missingProducts.some(missing => missing.product_id === product.product_id) && !this.insufficientInventory.some(insufficient => insufficient.product_id === product.product_id)),
              };
              // Lines are edited, not sent: the order is still on the detail page.
              this.cancelReturnToList();
              this.store.dispatch(
                EditQuotation({
                  id: this.quotation?.id!,
                  quotation: payload,
                  update_status: '0'
                })
              );
            }

            if (result?.newDate) {
                this.shippingDate = result.newDate;
                this.updateQuuote();
                this.confirmAction('to_be_validated', [], [], false, true);
            }
          });
        }
      } else if (action.type === CheckProductsAvailabilityError.type) {
        console.error('Error checking product availability');
      }

    } catch (error) {
      console.error('Unexpected error', error);
    }
  }

  removeUnavailableProducts() {
    if (!this.missingProducts?.length) return;
    this.missingProducts.forEach((entry) => {
      this.quoteProductsData.products = this.quoteProductsData.products.filter((p) => p.product_id !== entry.product_id);
    });
  }

  removeInsufficientProducts() {
    if (!this.insufficientInventory?.length) return;
    this.insufficientInventory.forEach((entry) => {
    this.quoteProductsData.products = this.quoteProductsData.products.filter((p) => p.product_id !== entry.product_id);});
  }

  updateAndSendQuote() {
    this.removeUnavailableProducts();
    this.setShippingDateToMaxProductsShippingDate();
    this.updateQuuote();
    this.sendAcceptQuote();
  }

  setShippingDateToMaxProductsShippingDate() {
    let maxTimestamp = 0;

    for (const entry of this.insufficientInventory) {
      if (!entry?.erp_delivery_date) continue;
      const t = Date.parse(entry.erp_delivery_date);
      if (!isNaN(t) && t > maxTimestamp) maxTimestamp = t;
    }

    if (maxTimestamp > 0) {
      this.shippingDate = new Date(maxTimestamp).toISOString().split('T')[0];
    }
  }

  getProductStatusIcon(product: IParseProduct): string {
    if (product.matched || product.added_manually) return 'manual-match-icon';
    if (this.isPreferredProductMatch(product)) return 'preferred-match-icon';
    if (product.has_alternatives) return 'check-list-icon';
    return 'check-icon';
  }

  isPreferredProductMatch(product: IParseProduct): boolean {
    const method = (product.ai_match_method || '').toLowerCase();
    const value = (product.ai_match_value || '').trim();
    return (method === 'preferred' || method === 'preferred_global') && /^\d+$/.test(value);
  }

  matchMethodBadge(product: IParseProduct): { labelKey: string; valueLabelKey: string; value: string } | null {
    const method = (product.ai_match_method || '').toLowerCase();
    const value = (product.ai_match_value || '').trim();
    if (!method || !value) return null;
    if (method === 'exact_alias') {
      return {
        labelKey: 'quotations_and_orders.match_method.perfect_alias',
        valueLabelKey: 'quotations_and_orders.match_method.alias_value',
        value,
      };
    }
    if (method === 'exact_code') {
      const field = (product.ai_match_field || '').toLowerCase();
      const fieldToLabel: Record<string, string> = {
        sku: 'quotations_and_orders.match_method.sku_value',
        ean: 'quotations_and_orders.match_method.ean_value',
        extra_identifier: 'quotations_and_orders.match_method.extra_identifier_value',
        external_reference: 'quotations_and_orders.match_method.external_ref_value',
      };
      const valueLabelKey = fieldToLabel[field] || 'quotations_and_orders.match_method.extra_identifier_value';
      return { labelKey: 'quotations_and_orders.match_method.perfect_code', valueLabelKey, value };
    }
    if ((method === 'preferred' || method === 'preferred_global') && /^\d+$/.test(value)) {
      return {
        labelKey: 'quotations_and_orders.match_method.preferred',
        valueLabelKey: method === 'preferred_global'
          ? 'quotations_and_orders.match_method.frequency_value_global'
          : 'quotations_and_orders.match_method.frequency_value',
        value,
      };
    }
    return null;
  }

  getProductMatchTooltip(product: IParseProduct): string {
    if (product.added_manually) {
      return this.translateService.instant('quotations_and_orders.match_method.tooltip_manually_added');
    }
    if (product.matched) {
      return this.translateService.instant('quotations_and_orders.match_method.tooltip_manually_matched');
    }
    const badge = this.matchMethodBadge(product);
    if (badge) {
      const label = this.translateService.instant(badge.labelKey);
      const valueLabel = this.translateService.instant(badge.valueLabelKey);
      return `${label} — ${valueLabel}: ${badge.value}`;
    }
    if (product.has_alternatives) {
      return this.translateService.instant('quotations_and_orders.match_method.tooltip_review_alternatives');
    }
    return this.translateService.instant('quotations_and_orders.match_method.tooltip_ok');
  }

  private isManualPick(product: IParseProduct): boolean {
    return !!(product.matched || product.added_manually);
  }

  isSkuMatchHighlight(product: IParseProduct): boolean {
    if (this.isManualPick(product)) return false;
    return (product.ai_match_method || '').toLowerCase() === 'exact_code'
      && (product.ai_match_field || '').toLowerCase() === 'sku';
  }

  getInlineMatchCode(product: IParseProduct): string | null {
    if (this.isManualPick(product)) return null;
    const method = (product.ai_match_method || '').toLowerCase();
    const value = (product.ai_match_value || '').trim();
    if (!value) return null;
    if (method === 'exact_alias') return value;
    if (method === 'exact_code' && (product.ai_match_field || '').toLowerCase() !== 'sku') return value;
    if ((method === 'preferred' || method === 'preferred_global') && /^\d+$/.test(value)) {
      // Chip is scope-free; the sublabel carries per-customer vs global.
      return this.translateService.instant('quotations_and_orders.match_method.frequency_inline', { count: value });
    }
    return null;
  }

  getSemanticParsedCodes(product: IParseProduct): string[] {
    const method = (product.ai_match_method || '').toLowerCase();
    if (method !== 'hybrid_reranked') {
      return [];
    }
    return (product.ai_extracted_codes || '')
      .split(',')
      .map(c => c.trim())
      .filter(Boolean);
  }

  getSemanticCodesForDisplay(product: IParseProduct): string[] {
    const method = (product.ai_match_method || '').toLowerCase();
    if (method === 'null') {
      // WB-7907: see side-by-side-correction-panel's getSemanticParsedCodes
      // -- a line manually matched from a previously AI-unmatched row has no
      // stale AI match reasoning to hide, so it's exempt from the WB-7829
      // manual-pick gate below. getSemanticParsedCodes() itself stays
      // 'hybrid_reranked'-only since it also feeds the enrich dialog.
      return (product.ai_extracted_codes || '')
        .split(',')
        .map(c => c.trim())
        .filter(Boolean);
    }
    return this.isManualPick(product) ? [] : this.getSemanticParsedCodes(product);
  }

  openMatchingMissingAiQuoteProducts(){
    const dialog = this.dialog.open(MatchingMissingAiQuoteProductsComponent, {
      data: {
        mode: 'unmatched_ai',
        quotationId: this.quoteId,
        products: this.unmatchedProducts,
        quoteProducts: this.quotation?.products,
        orderCustomerId: this.quotation?.location?.id_company,
      }
    });
    dialog.afterClosed().subscribe((result) => {
      if (result && (result.matches.length > 0 || result.toBeRemovedProducts.length > 0)) {
        this.store.dispatch(UpdateEmailOrder({ id: this.quoteId, payload: {
          matches: result.matches.length > 0 ? result.matches : undefined,
          unmateched_order_lines_to_remove: result.toBeRemovedProducts.length > 0 ? result.toBeRemovedProducts : undefined
        } }));
      }
    });
  }

  openMatchSingleOrderLineProduct(product: IParseProduct, event?: Event, isUnmatched: boolean = false) {
    // prevent row click (stock fulfillment) when using the match button
    event?.stopPropagation();

    const dialog = this.dialog.open(MatchingMissingAiQuoteProductsComponent, {
      data: {
        mode: 'single_order_line',
        quotationId: this.quoteId,
        isUnmatched,
        products: [product],
        quoteProducts: this.quotation?.products || [],
        orderCustomerId: this.quotation?.location?.id_company,
      },
      disableClose: true,
    });

    dialog.afterClosed().subscribe((result: any) => {
      if (!result) return;

      // Handle ignore action — dispatch immediately to create wl.ignored.code entry
      if (result.action === 'ignore') {
        this.store.dispatch(UpdateQuotationLines({
          id: this.quoteId,
          payload: {
            ignoreUnmatched: [{
              unmatched_line_id: product.order_line_id ?? product.id,
              code: result.code,
              extracted_name: result.extracted_name,
            }],
          },
        }));
        const removedId = product.order_line_id ?? product.id;
        this.unmatchedProducts = this.unmatchedProducts.filter(p => (p.order_line_id ?? p.id) !== removedId);
        return;
      }

      if (result.action === 'delete') {
        if (isUnmatched) {
          this.store.dispatch(UpdateQuotationLines({ id: this.quoteId, payload: {
            removeUnmatched: [product.id]
          }}));
        } else {
          if (!product.order_line_id) return;
          this.store.dispatch(UpdateQuotationLines({ id: this.quoteId, payload: {
            remove: [product.order_line_id]
          }}));
        }
        return;
      }

      if (!result?.selectedProduct?.id) return;

      if (isUnmatched) {
        this.store.dispatch(UpdateQuotationLines({ id: this.quoteId, payload: {
          matchUnmatched: [
            {
              unmatched_line_id: product.id,
              product_id: result.selectedProduct.id,
              ...(result.alwaysMatch ? { correction_intent: 'permanent' as const } : {}),
              ...(result.amtwCode ? { amtw_code: result.amtwCode } : {}),
            }
          ]
        }}));
      } else {
        if (!product.order_line_id) return;
        this.store.dispatch(UpdateQuotationLines({ id: this.quoteId, payload: {
          update: [
            {
              id: product.order_line_id,
              product_id: result.selectedProduct.id,
              ...(result.alwaysMatch ? { correction_intent: 'permanent' as const } : {}),
              ...(result.amtwCode ? { amtw_code: result.amtwCode } : {}),
            }
          ]
        }}));
      }
      // The line's product just changed -- the cached bulk alternatives map for this
      // quotation (keyed by the OLD product's alternatives/is_original flags) is stale.
      // The price-candidates cache is evicted by InvalidatePriceCandidatesEffect$ on
      // the line-update success, so it is not touched here: doing it now, before the
      // server has committed, would let a reload in between cache the old answer.
      this.services.clearAlternativesBulkCache(this.quoteId);
    });
  }

  changePrice(product: IParseProduct, event?: Event) {
    event?.stopPropagation();

    const catalogPrice = product.catalog_price ?? null;
    const aiPrice = product.ai_price ?? null;
    if (catalogPrice === null || aiPrice === null) return;
    if (aiPrice === catalogPrice) return;
    if (product.order_line_id == null) return;

    const isAiApplied = product.price_type === 'ai';
    const nextFinalPrice = isAiApplied ? catalogPrice : aiPrice;
    const nextPriceType: PriceSourceType = isAiApplied ? 'catalog' : 'ai';

    this.store.dispatch(
      UpdateQuotationLines({
        id: this.quoteId,
        payload: {
          update: [{
            id: product.order_line_id,
            final_price: nextFinalPrice,
            price_type: nextPriceType,
          }],
        },
      })
    );
  }

  openDuplicatedProductHandler(product: IParseProduct) {
    if (product.duplicated && !product.is_buy_x_get_y_line) {
      const data: IParseProduct[] = this.quotation?.products?.filter(p => (p.sku === product.sku) && !p.is_buy_x_get_y_line) || [];
      const dialogRef = this.dialog.open(DuplicateProductsHandlerComponent, {
        data: data
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.store.dispatch(DeleteDuplicateProducts({ id: this.quoteId, payload: { order_line_ids: result } }));
        }
      });
    }
  }

  editShippingAddress() {
    const company = this.quotation?.order_company
      ? { id: this.quotation.order_company.id, name: this.quotation.order_company.name }
      : null;
    const location = this.isLocationInformationMissing()
      ? null
      : { id: this.quotation?.location?.id, name: this.quotation?.location?.name };
    const dialogRef = this.dialog.open(CompaniesSelectionDialogComponent, {
      data: { company, location, canGoBack: false, mode: 'edit', initialStep: 'location', order_id: this.quoteId, shipping_date: this.shippingDate },
    });

    dialogRef.afterClosed().subscribe((selected) => this.applyCustomerSelection(selected));
  }

  // The delivery date is inline-editable in the "Order references" block, so
  // there is no separate edit-shipping dialog here.

  updateQuuote(){
    const payload: IUpdateQuotationDetails = {
      shipping_date: this.shippingDate,
      payment_terms: this.paymentTerms?.id,
      comment: this.comment,
      validity_date: this.validityDate,
      partner_id: this.partnerId,
      id_company: this.id_company,
      customer_po_number: this.customerPoNumber,
      quote_id: this.quoteIdValue,
    };
    this.store.dispatch(UpdateQuotationDetails({ id: this.quoteId, payload }));
  }

  // ── Configurable detail blocks (WB-7463) ──────────────────────────────────
  // `EditOrderConditionsComponent` used to own payment terms, PO number and
  // quote id behind one pencil. All three are inline-editable now, so the
  // dialog is no longer opened from here.

  /** Recompute every configurable block and re-apply the saved preferences. */
  private buildDetailFields(): void {
    const fields = this.orderDetailFields.build({
      location: this.quotation?.location,
      shippingLocation: this.quotation?.shipping_location,
      orderCompany: this.quotation?.order_company,
      paymentTerms: this.paymentTerms,
      paymentTermOptions: this.paymentTermOptions,
      customerPoNumber: this.customerPoNumber,
      quoteId: this.quoteIdValue,
      shippingDate: this.shippingDate,
      comment: this.comment,
      objectCustomFields: this.objectCustomFields,
      currentLanguage: this.currentLanguage,
      hiddenOrderFields: this.hiddenOrderFields,
      hasFreeShipping:
        this.featureFlags.loyaltyEnabled &&
        !!(this._orderDeals?.best_free_shipping || this.quotation?.best_free_shipping),
    });

    this.fieldGroups = fields.groups;
    this.customerFields = fields.customer;
    this.shippingFields = fields.shipping;
    this.orderReferenceFields = fields.references;
    this.orderCustomFieldRows = fields.customFields;
    // Cached rather than computed in the template: a new array on every change
    // detection run would re-create the tags each tick.
    // WB-7836 (review follow-up): the tax codes shown in the Shipping block
    // are the shipping location's own, not the Customer/billing location's.
    this.taxCodeTags = locationCodeTags(this.quotation?.shipping_location);
  }

  /** One block's visibility/order changed in the settings drawer. */
  onFieldGroupChange(change: IDetailFieldGroupChange): void {
    this.orderDetailFields.saveGroup(change, this.fieldGroups);
    this.buildDetailFields();
  }

  /** Rule behind a split, shown in the info popover on the Details block. */
  segregationRuleSummary(info: ISegregationInfo | ISegregationSplit): string {
    return this.orderDetailFields.segregationRuleSummary(info);
  }

  /** Full linked-order list, once there are too many to tag inline. */
  openLinkedOrders(quotation: IQuotationDetail): void {
    const splits = quotation.segregation_splits ?? [];
    if (!splits.length) return;
    this.dialog.open(LinkedOrdersModalComponent, {
      data: { orderName: quotation.name, splits },
      maxWidth: '95vw',
      autoFocus: 'dialog',
    });
  }

  /**
   * True when at least one order custom field is of a type the inline editor
   * cannot express, so the dialog is still worth offering.
   */
  hasDialogOnlyCustomFields(): boolean {
    return this.orderCustomFieldRows.some((field) => field.mode === 'readonly');
  }

  /** A `modal` row asked for its dialog. */
  onDetailFieldEdit(field: IDetailField): void {
    if (field.key === 'company') {
      this.editCustomer();
    } else if (field.key === 'location') {
      this.editShippingAddress();
    }
  }

  /** An `inline` row was saved. Persists just that field. */
  onDetailFieldValueChange(change: IDetailFieldChange): void {
    // Order custom fields are keyed by technical name and saved as a set.
    if (change.key.startsWith('order_custom_')) {
      this.saveInlineCustomField(change.key.replace('order_custom_', ''), change.value);
      return;
    }

    switch (change.key) {
      case 'payment_terms': {
        // `null` clears the term; anything else must resolve to a known one.
        const term = change.value === null
          ? null
          : this.paymentTermOptions.find((option) => option.id === change.value);
        if (term === undefined) return;
        this.paymentTerms = term;
        this.store.dispatch(UpdateQuotationDetails({
          id: this.quoteId,
          payload: { payment_terms: term?.id ?? null },
        }));
        break;
      }
      case 'customer_po_number':
        this.customerPoNumber = (change.value as string) ?? '';
        this.store.dispatch(UpdateQuotationDetails({
          id: this.quoteId,
          payload: { customer_po_number: this.customerPoNumber },
        }));
        break;
      case 'quote_id':
        this.quoteIdValue = (change.value as string) ?? '';
        this.store.dispatch(UpdateQuotationDetails({
          id: this.quoteId,
          payload: { quote_id: this.quoteIdValue },
        }));
        break;
      case 'shipping_date':
        this.shippingDate = (change.value as string) ?? '';
        this.store.dispatch(UpdateQuotationDetails({
          id: this.quoteId,
          payload: { shipping_date: this.shippingDate },
        }));
        break;
      case 'internal_note':
        this.comment = (change.value as string) ?? '';
        this.store.dispatch(UpdateQuotationDetails({
          id: this.quoteId,
          payload: { comment: this.comment },
        }));
        break;
    }
    this.buildDetailFields();
  }

  /** Persist one custom field without disturbing the others. */
  private saveInlineCustomField(technicalName: string, value: string | number | null): void {
    const definition = this.objectCustomFields?.definitions?.find(
      (item) => item.technical_name === technicalName
    );
    // The boolean picker round-trips 'true'/'false' strings; store real booleans.
    const stored =
      definition?.field_type === CustomFieldTypes.BOOLEAN && value !== null
        ? value === 'true'
        : value;

    const values = {
      ...(this.objectCustomFields?.values ?? {}),
      [technicalName]: stored as string,
    };
    this.objectCustomFields = this.objectCustomFields
      ? { ...this.objectCustomFields, values }
      : this.objectCustomFields;
    this.saveOrderCustomFields(values);
    this.buildDetailFields();
  }

  openLineNotesDialog(item: IParseProduct): void {
    const editable = this.stillEditable() && this.canEdit;
    this.dialog
      .open(ProductNotesDialogComponent, {
        data: {
          productName: item.name,
          productImage: item.image,
          note: item.notes ?? '',
          editable,
        },
      })
      .afterClosed()
      .subscribe((result: IProductNotesDialogResult | undefined) => {
        // result is undefined when the dialog is cancelled/closed without saving.
        if (!result || !editable) return;
        if ((item.notes ?? '') === result.note) return;
        if (item.order_line_id == null) return;
        this.store.dispatch(
          UpdateQuotationLines({
            id: this.quoteId,
            payload: { update: [{ id: item.order_line_id, notes: result.note }] },
          }),
        );
      });
  }

  addComment() {
    if(!this.stillEditable()) return;
    this.dialog.open(EditCommentComponent, {
      data: {
        comment: this.comment
      }
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.comment = result.comment;
        this.updateQuuote();
      }
    });
  }

  // `editCustomerPoNumber` (EditCustomerPoNumberComponent) removed by WB-7463 —
  // the PO number is inline-editable in the "Order references" block.

  editCustomFields() {
    this.dialog.open(OrderCustomFieldsComponent, {
      data: {
        objectCustomFields: this.objectCustomFields
      }
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.saveOrderCustomFields(result);
      }
    });
  }

  saveOrderCustomFields(values: IObjectCustomFields['values']): void {
    this.store.dispatch(
      UpdateObjectCustomFields({
        params: { ...this.objectCustomFieldsParams },
        values,
      })
    );
  }

  sendQuote() {
    this.store.dispatch(SendQuotation({ id: this.quoteId }));
  }

  resendQuote() {
    if (this.quotation?.products?.some(product => !product.final_price)) {
      return;
    }
    this.store.dispatch(ResendQuotation({ id: this.quoteId }));
  }

  accept() {
    this.store.dispatch(AcceptQuotation({ id: this.quoteId }));
  }

  sendAcceptQuote() {
    this.store.dispatch(SendQuotation({ id: this.quoteId, accept: true }));

  }

  iconStatus(status: string) {
    switch (status) {
      case 'QUOTATION_ACCEPTED':
        return 'assets/icones/double_tick.svg';
      default:
        return 'assets/icones/send_quote.svg';
    }
  }

  downloadFile(quotation: { id: number; status?: string }, type: string) {
    this.store.dispatch(SetQuotationsLoader({ isLoading: true }));
    this.services.getPdfQuotation(quotation.id).subscribe({
      next: (res) => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        if (type === 'open') {
          window.open(url);
        } else if (type === 'download') {
          const isOrder = quotation.status === 'sale' || quotation.status === 'done';
          const a = document.createElement('a');
          a.href = url;
          a.download = `${isOrder ? 'order' : 'quotation'}-${quotation.id}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url); // Clean up
        }
      },
      error: () => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
      }
    });
  }

  downloadCsv(quotation: { id: number; status?: string; products?: IParseProduct[] }) {
    const isOrder = quotation.status === 'sale' || quotation.status === 'done';
    const filename = `${isOrder ? 'order' : 'quotation'}-${quotation.id}.csv`;

    if (quotation.products?.length) {
      this.exportService.downloadProductsCsv(quotation.products, filename);
      return;
    }

    if (!quotation.id) return;
    this.store.dispatch(SetQuotationsLoader({ isLoading: true }));
    this.services.getQuotationById(quotation.id).pipe(take(1)).subscribe({
      next: (res) => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
        if (res.object?.products?.length) {
          this.exportService.downloadProductsCsv(res.object.products, filename);
        } else {
          this.commonService.showToast(
            this.translateService.instant('quotations_and_orders.csv_no_products'),
            'WARNING'
          );
        }
      },
      error: () => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
      }
    });
  }

  downloadFileInvoice(quotation: IQuotationDetail) {
    this.store.dispatch(SetQuotationsLoader({ isLoading: true }));
    this.services.getPdfInvoice(quotation.id).subscribe({
      next: (res) => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      error: (err) => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
      }
    });
  }

  cancel(id: number) {
    this.store.dispatch(cancelQuotation({ id: id }));
  }
  deleteQuote(id: number) {
    this.store.dispatch(deleteQuotation({ id: id, confirm: true }));
  }

  duplicateQuote(id: number) {
    this.store.dispatch(DuplicateQuotation({ id }));
  }

  archiveQuote(id: number, name?: string) {
    this.store.dispatch(ArchiveQuotation({ id, quotationName: name }));
  }

  unarchiveQuote(id: number) {
    this.store.dispatch(UnarchiveQuotation({ id }));
  }

  isErpSynced(quotation: IQuotationDetail | null | undefined): boolean {
    if (!quotation) return false;
    return ['done', 'sent_to_erp'].includes(quotation.status) || !!quotation.external_id;
  }

  isQuotationArchived(quotation: IQuotationDetail | null | undefined): boolean {
    return !!quotation?.is_archived;
  }

  canShowArchiveAction(quotation: IQuotationDetail | null | undefined): boolean {
    return !!quotation && !this.isErpSynced(quotation) && !this.isQuotationArchived(quotation);
  }

  canShowDeleteAction(quotation: IQuotationDetail | null | undefined): boolean {
    if (!quotation) return false;
    return !['done', 'sent_to_erp'].includes(quotation.status);
  }

  invoiceOrder(id: number) {
    const dialog = this.dialog.open(GenerateInvoicePopUpComponent, {
      data: {
        id: id,
        confirm_class: 'btn-primary',
      },
      disableClose: true
    });
    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(invoiceQuotation({ id: id }));
      }
    });
  }
  isQuotationExpired(): boolean {
    if (!this.quotation) {
      return false;
    }
    const validityDate = new Date(this.quotation.validity_date);
    return !isNaN(validityDate.getTime()) && validityDate < new Date();
  }
  isQuotationNotExpired(): boolean {
    return !this.isQuotationExpired();
  }
  navigateBack() {
    this.router.navigate(['../'], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge'
    });
  }

  canDownloadInvoice(quotation: any): boolean {
    return quotation.invoice_status === 'invoiced';
  }

  getUnitPrice(product: IParseProduct): number {
    // If final_price exists, use it
    if (product.final_price) {
      return product.final_price;
    }

    // Otherwise calculate based on pricing rule
    if (this.isMarginOnCost && product.cost && product.cost > 0) {
      // Margin mode: final_price = cost * (1 + margin/100)
      return product.cost * (1 + (product.discount / 100));
    }

    // Discount mode: final_price = price_unit * (1 - discount/100)
    return product.price_unit ? (product.price_unit * (1 - (product.discount / 100))) : 0;
  }

  getTotalAmount(product: IParseProduct): number {
    return product.total;
  }

  getQuotationTotalPrice(quotation: IQuotationDetail) {
    return quotation?.amount_total ?? 0;
  }

  getLatestQuotationTotalPrice() {
    return this.quotation?.amount_total ?? 0;
  }

  getOrderMarginAmount(): number {
    if (!this.isMarginOnCost) return 0;
    return Number((this.quotation?.margin_total ?? 0).toFixed(2));
  }

  getOrderMarginPercentage(): number {
    if (!this.isMarginOnCost) return 0;
    const totalCost = this.quotation?.cost_total ?? 0;
    if (totalCost === 0) return 0;
    const marginAmount = this.quotation?.margin_total ?? 0;
    const marginPercentage = (marginAmount / totalCost) * 100;
    return Number(marginPercentage.toFixed(2));
  }

  ngOnDestroy(): void {
    this.onAutocompleteClosed();
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptions.forEach(sub => sub.unsubscribe());
    // The store is app-wide: releasing (not clearing) drops the last order's
    // candidates only when no other surface is still showing them.
    this.priceCandidates.release();
    this.store.dispatch(clearQuotations());
  }

  handleSelectedProducts(products: IProduct[]): void {
    // Used by both "from catalog" and "from all products" flows
    this.selectedProductsToAdd = products;

    // Keep quoteProductsData in sync so the header "Add selection to order" flow works predictably.
    const newProducts: IParseProduct[] = this.selectedProductsToAdd.map(product => {
      const defaultHU = product.handling_units?.find(hu => hu.default === true) || product.handling_units?.[0];
      const defaultHUId: number | undefined = defaultHU?.id;

      return {
        id: product.id || 0,
        name: product.name,
        quantity: product.quantity || product.min_qte || 1,
        sku: product.sku,
        erp_id: product.erp_id,
        barcode: product.barcode,
        discount: product.discount || 0,
        price_unit: this.getSalePrice(product),
        final_price: product.final_price ? product.final_price : this.calculateFinalPrice(product, product.discount || 0),
        image: product.image,
        cost: this.getCurrencyCost(product) ?? product.cost,
        increment: product.increment,
        max_qte: product.max_qte,
        min_qte: product.min_qte,
        total: this.getSalePrice(product) * (product.min_qte || 1),
        is_owned: product.is_owned,
        brand: product.brand?.name,
        description: product.description,
        status: product.status,
        brand_id: product.brand_id,
        brand_name: product.brand?.name,
        categories: product.categories,
        category_id: product.category_id!,
        stock_by_warehouse: product.stock_by_warehouse,
        reserved_stock: product.reserved_stock || [],
        handling_units: product.handling_units || [],
        handling_unit_id: defaultHUId,
        stock_reservation: [{
          id: 0,
          state: 'draft',
          warehouse_id: this.primaryWarehouse(product)?.warehouse_id || 0,
          order_id: this.lastQuotationId,
          stock_id: this.primaryWarehouse(product)?.stock_id || 0,
          quantity: product.min_qte || 1,
        }],
        currencies: product.currencies || [],
      };
    });

    // Update quoteProductsData with both existing and new products

    // Get existing products and create a map for quick lookup
    const existingProducts = this.quoteProductsData?.products || [];
    const existingProductsMap = new Map<number, IParseProduct>();
    existingProducts.forEach(p => {
      const productId = p.id || p.product_id;
      if (productId) {
        existingProductsMap.set(productId, p);
      }
    });

    // Create a Set of selected product IDs for filtering
    const selectedProductIds = new Set(products.map(p => p.id).filter(id => id !== undefined && id !== null));

    // Build the final products array based on selected products
    const finalProducts: IParseProduct[] = this.selectedProductsToAdd.map(selectedProduct => {
      const productId = selectedProduct.id;

      // If product exists in existing products, keep it unchanged
      if (productId && existingProductsMap.has(productId)) {
        return existingProductsMap.get(productId)!;
      }

      // Otherwise, create a new product from the selected catalog product
      return {
        id: productId || 0,
        name: selectedProduct.name,
        quantity: selectedProduct.quantity || selectedProduct.min_qte || 1,
        sku: selectedProduct.sku,
        erp_id: selectedProduct.erp_id,
        barcode: selectedProduct.barcode,
        discount: selectedProduct.discount || 0,
        price_unit: this.getSalePrice(selectedProduct),
        final_price: selectedProduct.final_price ? selectedProduct.final_price : this.getSalePrice(selectedProduct) * (1 - (selectedProduct.discount || 0) / 100),
        image: selectedProduct.image,
        cost: selectedProduct.cost,
        increment: selectedProduct.increment,
        max_qte: selectedProduct.max_qte,
        min_qte: selectedProduct.min_qte,
        total: this.getSalePrice(selectedProduct) * (selectedProduct.min_qte || 1),
        is_owned: selectedProduct.is_owned,
        brand: selectedProduct.brand?.name,
        description: selectedProduct.description,
        status: selectedProduct.status,
        brand_id: selectedProduct.brand_id,
        brand_name: selectedProduct.brand?.name,
        categories: selectedProduct.categories,
        category_id: selectedProduct.category_id!,
        stock_by_warehouse: selectedProduct.stock_by_warehouse,
        reserved_stock: selectedProduct.reserved_stock || [],
        stock_reservation: [{
          id: 0,
          state: 'draft',
          warehouse_id: this.primaryWarehouse(selectedProduct)?.warehouse_id || 0,
          order_id: this.lastQuotationId,
          stock_id: this.primaryWarehouse(selectedProduct)?.stock_id || 0,
          quantity: selectedProduct.min_qte || 1,
        }],
        currencies: selectedProduct.currencies || [],
      };
    });

    // Update quoteProductsData with the final products array
    // This ensures we only have products from selectedCatalogProducts
    this.quoteProductsData = {
      ...this.quoteProductsData,
      products: finalProducts
    };
  }

  handleQuoteProductsUpdate(updatedQuoteData: IQuoteProductData): void {
    this.quoteProductsData = updatedQuoteData;

    // If we have temporary data, update it as well to maintain consistency
    if (this.temporaryQuoteData) {
      this.temporaryQuoteData = JSON.parse(JSON.stringify(updatedQuoteData));
    }
    // Set changes flag when products are updated
    this.hasQuoteChanges = true;
  }

  handleQuoteChanges(hasChanges: boolean): void {
    this.hasQuoteChanges = hasChanges;
  }

  handleFormValidity(isValid: boolean): void {
    this.isFormValid = isValid;
  }

  handleIntentChange(intent: number): void {
    this.intent = intent;
  }

  UpdateOrder(): boolean | void {
    if(this.quoteProductsData.products.length === 0){
      this.commonService.showToast(
        this.translateService.instant('quotations_and_orders.no_products_selected'),
        'WARNING'
      );
      return false
    }
    if (this.quoteProductsData && this.isFormValid) {
      const payload: IAskForQuotation = {
        pricelist_id: this.quoteProductsData.pricelist_id,
        is_final: false,
        currency_id: this.quoteProductsData?.currency?.id ?? this.quoteCurrency?.id ?? this.locationCurrency?.id ?? null,
        products: this.quoteProductsData.products.map(product => {
          let quantity = product.quantity;

          if (product.quantity_handling_unit !== null && product.quantity_handling_unit !== undefined && product.handling_unit_id && product.handling_units) {
            const selectedHU = product.handling_units.find(hu => hu.id === product.handling_unit_id);
            const mult = handlingUnitBaseMultiplier(selectedHU);
            if (selectedHU && mult > 0) {
              quantity = product.quantity_handling_unit * mult;
            }
          }

          return {
            product_id: product.id,
            name: product.name,
            quantity: quantity,
            handling_unit_id: product.handling_unit_id,
            discount: product.discount,
            extra_discount: product.extra_discount,
            increment: product.increment,
            min_qte: product.min_qte,
            max_qte: product.max_qte,
            sku: product.sku,
            price_unit: product.price_unit,
            final_price: product.final_price,
            total_discount: product.discount,
            stock_reservation:
              product.stock_reservation && product.stock_reservation?.length > 0
                ? product.stock_reservation
                : product.stock_by_warehouse
                    ?.filter((stock: any) => stock.is_primary && stock.warehouse_id !== null)
                    .map((stock: any) => ({
                      warehouse_id: stock.warehouse_id,
                      quantity: quantity,
                    })) || [],
            order_line_id: product.order_line_id
          };
        })
      };

      if(this.quotation?.status === 'draft') {
        this.store.dispatch(EditDraftQuotation({ id: this.quoteProductsData.quotation_id, quotation: payload }));
      } else {
        this.store.dispatch(EditQuotation({ id: this.quoteProductsData.quotation_id, quotation: payload, update_status: '1' }) );
      }
      // Clear temporary data when updating the quote
      this.temporaryQuoteData = null;
      this.setPage('details');
    }
  }

  UpdateEmailOrder(){
    this.store.dispatch(UpdateEmailOrder({ id: this.quoteId, payload: { intent: this.intent } }));
    this.setPage('details');
  }

  onExtractedNotesSave(extracted: IExtractedNote[]): void {
    if (this.extractedNotes) {
      this.extractedNotes = { ...this.extractedNotes, extracted };
    }
    this.store.dispatch(UpdateAiNotes({ id: this.quoteId, payload: { notes: extracted } }));
  }

  sumAvailableQuantity(product: IParseProduct): number {
    return (
      product.stock_by_warehouse?.reduce((acc, stock) => acc + stock.available_quantity, 0) ||
      0
    );
  }

  reservedQuantity(product: IParseProduct): number {
    return (
      (product.reserved_stock || [])?.reduce(
        (sum: number, reservedStock: any) =>
          sum + (reservedStock.state == 'reserved' && reservedStock.order_id === this.lastQuotationId ? reservedStock.quantity : 0),
        0
      ) || 0
    );
  }

  outOfStock(product: IParseProduct): boolean {
    const reservedQuantity = this.reservedQuantity(product);
    return this.sumAvailableQuantity(product) + reservedQuantity < product.quantity;
  }

  reservedQuantityOnWarehouse(product: IParseProduct, warehouseId: number): number {
    return (
      (product.reserved_stock || [])?.find(
        (reservedStock) =>
          reservedStock.warehouse_id === warehouseId && reservedStock.order_id === this.lastQuotationId && reservedStock.state !== 'reserved'
      )?.quantity || 0
    );
  }

  primaryWarehouse(product: any): IStockByWarehouse | undefined {
    return product.stock_by_warehouse?.find((stock: any) => stock.is_primary && stock.warehouse_id !== null);
  }

  outOfStockMainWarehouse(product: IParseProduct): boolean {
    const mainWarehouse = this.primaryWarehouse(product);
    const reservedQuantityOnMainWarehouse = this.reservedQuantityOnWarehouse(product, mainWarehouse?.warehouse_id || 0);
    return (mainWarehouse?.available_quantity || 0) < reservedQuantityOnMainWarehouse;
  }

  hasErrorStock(product: IParseProduct): boolean {
    return this.outOfStock(product) || this.outOfStockMainWarehouse(product);
  }

  showStockFulfillment(product: IParseProduct) {
    if (product.order_line_id && this.quotation?.id) {
      this.services.getOrderLineStock(this.quotation.id, product.order_line_id).subscribe({
        next: (res: any) => {
          const enriched = {
            ...product,
            stock_by_warehouse: res.object?.stock_by_warehouse || [],
            reserved_stock: res.object?.reserved_stock || [],
            stock_reservation: res.object?.stock_reservation || [],
          };
          this.selectedStockFulfillmentProduct = enriched;
          this.isStockFulfillmentVisible = true;
        },
        error: () => {
          this.selectedStockFulfillmentProduct = product;
          this.isStockFulfillmentVisible = true;
        }
      });
    } else {
      this.selectedStockFulfillmentProduct = product;
      this.isStockFulfillmentVisible = true;
    }
  }

  isMultiWarehouseStock(product: IParseProduct): boolean {
    return product.has_multi_warehouse || false;
  }

  closeStockFulfillment() {
    this.isStockFulfillmentVisible = false;
    this.selectedStockFulfillmentProduct = null;
  }

  handleReservationChanged(product: any) {
    const products =
      this.quotation?.products?.map((p) =>
        p.id === product.id
          ? product
          : {
              ...p,
              stock_reservation: p.stock_reservation || [],
            }
      ) || [];
    this.quoteProductsData = {
      products: products.filter(product => product.quantity > 0 && product.final_price > 0),
      pricelist_id: this.quotation?.pricelist_id!,
      quotation_id: this.quotation?.id!,
      location_id: this.quotation?.location.id!,
      pricelist_name: this.quotation?.pricelist_name!,
      source: this.quotation?.channel!,
      currency: this.quotation?.currency!,
      catalog_default_handling_unit: this.quoteProductsData?.catalog_default_handling_unit
    };
    this.handleFormValidity(true);
    this.UpdateOrder();
  }

  getSalePrice(product: IProduct): number {
    const currencyId = this.quoteProductsData?.currency?.id;
    if (currencyId && Array.isArray(product.currencies)) {
      return product.currencies.find((c) => c.currency_id === currencyId)?.sales_price ?? 0;
    }
    return product.sales_price;
  }

  getCurrencyCost(product: IProduct): number | null {
    // Get cost from selected currency or fallback to product.cost
    const selectedCurrency = product.currencies?.find(currency => currency.currency_id === this.quoteProductsData.currency?.id);
    return selectedCurrency?.cost ?? product.cost ?? null;
  }

  calculateFinalPrice(product: IProduct, discount: number): number {
    // In margin mode, calculate from cost: final_price = cost * (1 + margin/100)
    if (this.isMarginOnCost) {
      const cost = this.getCurrencyCost(product);
      if (cost && cost > 0) {
        return cost * (1 + (discount / 100));
      }
      return (product as any).final_price || 0;
    }

    // Original discount mode: final_price = price_unit * (1 - discount/100)
    const priceUnit = this.getSalePrice(product);
    if (priceUnit) {
      return discount
        ? priceUnit * (1 - (discount / 100))
        : priceUnit;
    }
    return 0;
  }

  // Helper methods for handling units in template
  getSelectedHandlingUnit(handlingUnits: any[] | undefined, handlingUnitId?: number | null): any | null {
    if (!handlingUnits || handlingUnits.length === 0) {
      return null;
    }
    if (handlingUnitId !== null && handlingUnitId !== undefined) {
      const byId = handlingUnits.find((hu: any) => hu.id === handlingUnitId);
      if (byId) return byId;
    }
    return handlingUnits.find((hu: any) => hu.selected) || handlingUnits.find((hu: any) => hu.default) || null;
  }

  /** @see quantityInBaseUnitsTranslationParams */
  quantityInBaseUnitsExplainParamsLine(item: { quantity_handling_unit?: number | null; handling_units?: any[] }, selectedHu: any): {
    sellingQty: string;
    multiplier: string;
    baseUnits: string;
  } {
    const baseUnit = (item.handling_units as IProductHandlingUnit[] | undefined)?.find(u => u.is_base_unit);
    return quantityInBaseUnitsTranslationParams(item.quantity_handling_unit, selectedHu, baseUnit);
  }

  calculateQuantityHandlingUnit(quantity: number, handlingUnits: any[] | undefined): number | null {
    const selectedHU = this.getSelectedHandlingUnit(handlingUnits);
    const mult = handlingUnitBaseMultiplier(selectedHU);
    if (!selectedHU || mult <= 0) {
      return null;
    }
    return Math.floor(quantity / mult);
  }

  Math = Math;

  // Inline quantity editing methods
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const inOverlay = target.closest('.cdk-overlay-container');
    if (this.editingQuantityProductId !== null && !target.closest('.qty-inline-edit-container') && !inOverlay) {
      this.cancelEditQuantity();
    }
    if (this.editingDeliveryProductId !== null && !target.closest('.delivery-inline-edit-container') && !inOverlay) {
      this.cancelEditDelivery();
    }
    if (this.editingPriceProductId !== null && !target.closest('.price-inline-edit-container') && !inOverlay) {
      this.cancelEditPrice();
    }
  }

  isEditingQuantity(item: IParseProduct): boolean {
    return this.editingQuantityProductId === item.order_line_id;
  }

  startEditQuantity(item: IParseProduct): void {
    this.editingQuantityProductId = item.order_line_id ?? null;
    this.editQuantityHU = item.quantity_handling_unit ?? item.quantity ?? 0;
    this.editHandlingUnitId = item.handling_unit_id ?? null;
  }

  cancelEditQuantity(): void {
    this.editingQuantityProductId = null;
  }

  /**
   * `overrides` lets a caller submit explicit handling-unit/quantity values instead of the live
   * `editHandlingUnitId` / `editQuantityHU` fields — those are single fields shared across every
   * row, so a caller resuming after an async gap (see `openCreateSellingUnit`) can't safely assume
   * they still describe `item` by the time it runs.
   */
  submitEditQuantity(item: IParseProduct, overrides?: { handlingUnitId?: number | null; quantityHU?: number }): void {
    const handlingUnitId = overrides?.handlingUnitId ?? this.editHandlingUnitId;
    const quantityHU = overrides?.quantityHU ?? this.editQuantityHU;
    const selectedHU = this.getHandlingUnitById(item.handling_units, handlingUnitId);
    const unitQty = handlingUnitBaseMultiplier(selectedHU);
    const baseUnit = (item.handling_units as IProductHandlingUnit[] | undefined)?.find(u => u.is_base_unit);
    const quantity = applyHandlingUnitRounding(quantityHU * unitQty, baseUnit);

    this.store.dispatch(UpdateQuotationLines({
      id: this.quoteId,
      payload: {
        update: [{
          id: item.order_line_id!,
          handling_unit_id: handlingUnitId!,
          quantity_handling_unit: quantityHU,
          quantity,
          // Pin the current price so a quantity change does not cause the
          // backend to recompute/reset it (e.g. a manual override or applied AI price).
          ...(item.final_price != null ? { final_price: item.final_price } : {}),
          ...(item.price_type ? { price_type: item.price_type } : {}),
        }]
      }
    }));
    // Only exit edit mode if this row is still the one being edited (a create-selling-unit
    // submit resuming after an async gap may run after the user has moved to another row).
    if (this.editingQuantityProductId === item.order_line_id) {
      this.editingQuantityProductId = null;
    }
  }

  onEditQuantityInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val = input?.value ?? '';
    this.editQuantityHU = val === '' ? 0 : Math.max(0, Number(val));
  }

  onEditHandlingUnitChange(event: any, item: IParseProduct): void {
    if (event.value === this.HU_CREATE_SENTINEL) {
      // Not a real unit: revert the control to the current selection and open the modal.
      if (event.source) {
        event.source.value = this.editHandlingUnitId;
      }
      this.openCreateSellingUnit(item);
      return;
    }
    this.editHandlingUnitId = event.value;
  }

  /**
   * Shortcut for WB-5818: create a Volta-managed selling unit for this line's product without
   * leaving the order. Reuses the existing inventory modal; on success re-fetches the product's
   * handling units (the PUT only returns a message + id) and auto-selects the newly created unit.
   */
  openCreateSellingUnit(item: IParseProduct): void {
    const productTemplateId = (item.product_template_id ?? item.product_id) as number | undefined;
    const productId = (item.product_id ?? item.id) as number | undefined;
    if (productId == null) return;
    const prevIds = new Set((item.handling_units ?? []).map((u: IProductHandlingUnit) => u.id));
    // Snapshot now, while this row's edit UI is still the active one: `editQuantityHU` is a single
    // field shared across all rows, so re-reading `this.editQuantityHU` after the async gap below
    // could pick up whatever value another row has since typed (if the user moved on before this
    // fetch resolved). The row to persist to (`item.order_line_id`) is safe either way since it's
    // captured by closure, not read from shared state.
    const snapshotQtyHU = this.editQuantityHU;

    this.dialog
      .open(HandlingUnitsDialogueComponent, {
        data: { productVariantId: productId, existingUnits: item.handling_units },
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((created: boolean) => {
        if (!created) return;
        if (productTemplateId == null) return;
        this.productsService.getProductInventoryDetails(productTemplateId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            const units = this.handlingUnitsFromInventory(res?.object, productId);
            // `combinedLines` hands the template a throwaway shallow copy of each row, so mutating
            // `item` alone is dropped on the next render (the getter rebuilds the copy from the
            // untouched source array). Update the stored line object so the dropdown picks it up.
            const liveLine = this.liveLine(item);
            liveLine.handling_units = units;
            item.handling_units = units;
            const newUnit = units.find((u) => !prevIds.has(u.id));
            if (!newUnit) return;

            liveLine.handling_unit_id = newUnit.id;
            // Keep the inline dropdown's own field in sync only if it's still showing this row —
            // otherwise it now belongs to whatever row the user has since started editing.
            if (this.editingQuantityProductId === item.order_line_id) {
              this.editHandlingUnitId = newUnit.id;
            }
            // Auto-select the newly created unit and persist the line immediately, using the
            // snapshotted quantity rather than the (possibly now-stale) shared `editQuantityHU`.
            this.submitEditQuantity(item, { handlingUnitId: newUnit.id, quantityHU: snapshotQtyHU });
          });
      });
  }

  /**
   * Resolve a row to the stored object in `productsQuote` / `unmatchedProducts` rather than the
   * shallow copy `combinedLines` hands the template. Keyed by `order_line_id` (always set in
   * quantity edit mode); falls back to the passed row.
   */
  private liveLine(item: IParseProduct): IParseProduct {
    const key = item.order_line_id;
    if (key != null) {
      return (
        this.productsQuote.find((p) => p.order_line_id === key) ??
        this.unmatchedProducts.find((p) => p.order_line_id === key) ??
        item
      );
    }
    return item;
  }

  /** Pick the handling units for `productId` from an inventory-details response (variant-aware). */
  private handlingUnitsFromInventory(details: IProductInventoryDetails | undefined, productId: number): IProductHandlingUnit[] {
    if (!details) return [];
    const variant = details.variants?.find((v) => v.product_id === productId);
    return (variant?.handling_units ?? details.handling_units ?? []) as IProductHandlingUnit[];
  }

  getHandlingUnitById(handlingUnits: any[] | undefined, id: number | null): any | null {
    if (!handlingUnits || id === null || id === undefined) return null;
    return handlingUnits.find((hu: any) => hu.id === id) || null;
  }

  // delivery date inline edit
  getDeliveryDateInputValue(product: IParseProduct): Date | null {
    const raw = product?.delivery_date as string | Date | undefined;
    if (!raw) return null;
    const date = raw instanceof Date ? raw : new Date(raw);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  isEditingDelivery(item: IParseProduct): boolean {
    return this.editingDeliveryProductId === item.order_line_id;
  }

  startEditDelivery(item: IParseProduct): void {
    this.editingDeliveryProductId = item.order_line_id ?? null;
    this.editDeliveryDate = this.getDeliveryDateInputValue(item);
  }

  cancelEditDelivery(): void {
    this.editingDeliveryProductId = null;
    this.editDeliveryDate = null;
  }

  submitEditDelivery(item: IParseProduct): void {
    if (!this.editDeliveryDate) {
      this.cancelEditDelivery();
      return;
    }
    const delivery_date = this.editDeliveryDate.toISOString().slice(0, 10);
    this.store.dispatch(UpdateQuotationLines({
      id: this.quoteId,
      payload: {
        update: [{
          id: item.order_line_id!,
          delivery_date
        }]
      }
    }));
    this.editingDeliveryProductId = null;
    this.editDeliveryDate = null;
  }

  getFormattedDeliveryDate(item: IParseProduct): string {
    const raw = item?.delivery_date as string | Date | undefined;
    if (!raw) return '--';
    const date = raw instanceof Date ? raw : new Date(raw);
    if (Number.isNaN(date.getTime())) return '--';
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  onDeliveryDateChange(event: MatDatepickerInputEvent<Date>, product: IParseProduct): void {
    this.editDeliveryDate = event.value ?? null;
  }

  // Inline price editing methods
  isEditingPrice(item: IParseProduct): boolean {
    return this.editingPriceProductId === item.order_line_id;
  }

  startEditPrice(item: IParseProduct): void {
    // Defense in depth (WB-7024): the UI already hides this trigger for a
    // no-price order, but guard the entry point itself too.
    if (this.quotation?.all_lines_no_price) return;
    this.editingPriceProductId = item.order_line_id ?? null;
    this.editPriceValue = roundPrice(item.final_price) ?? 0;
  }

  cancelEditPrice(): void {
    this.editingPriceProductId = null;
  }

  onEditPriceInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val = input?.value ?? '';
    // Rounded, not padded: padding would rewrite the field mid-keystroke.
    this.editPriceValue = val === '' ? 0 : Math.max(0, roundPrice(Number(val)) ?? 0);
  }

  /** The line whose full candidate list is open, or null. */
  candidatesPanelProduct: IParseProduct | null = null;

  submitEditPrice(item: IParseProduct): void {
    // Defense in depth (WB-7024): the UI already hides this input for a
    // no-price order, but guard the entry point itself too.
    if (this.quotation?.all_lines_no_price) {
      this.cancelEditPrice();
      return;
    }
    const newPrice = roundPrice(this.editPriceValue) ?? 0;
    if (newPrice <= 0) {
      this.cancelEditPrice();
      return;
    }

    // Auto-detect price type. The cascade itself lives in the store, so the
    // three surfaces that price a line cannot label the same keystroke
    // differently.
    const priceType: PriceSourceType = this.priceCandidates.priceTypeFor(
      item,
      orderLineProductId(item),
      newPrice
    );

    // Compute discount relative to MSRP (price_unit)
    const base = typeof item.price_unit === 'number' ? item.price_unit : null;
    let nextDiscount: number | null = null;
    if (base && base > 0) {
      nextDiscount = Number(((1 - newPrice / base) * 100).toFixed(2));
    }

    this.store.dispatch(
      UpdateQuotationLines({
        id: this.quoteId,
        payload: {
          update: [{
            id: item.order_line_id!,
            final_price: newPrice,
            price_type: priceType,
          }]
        }
      })
    );
    this.editingPriceProductId = null;
  }

  /**
   * One resolve call for the whole page of lines.
   *
   * Asked once per (customer, product set): the tooltip of every line and the
   * expanded panel all read the same answer, so they cannot disagree. No
   * customer on the order means no question to ask — a price is always a price
   * for someone — and the tooltip then renders only the line's own stored
   * prices.
   */
  loadPriceCandidates(): void {
    this.priceCandidates.loadForLines(
      this.quotation?.location?.id_company,
      (this.quotation?.products ?? []).map((product) => orderLineProductId(product)),
      this.quotation?.location?.id ?? null,
      this.quoteId ?? null
    );
  }

  candidatesFor(item: IParseProduct): IPriceCandidate[] {
    return this.priceCandidates.candidates(orderLineProductId(item));
  }

  policyTraceFor(item: IParseProduct): IPricePolicyTrace | null {
    return this.priceCandidates.policyTrace(orderLineProductId(item));
  }

  /** What the engine would apply — never re-derived, always the store's answer. */
  selectedCandidateFor(item: IParseProduct): IPriceCandidate | null {
    return this.priceCandidates.selected(orderLineProductId(item));
  }

  /** The expanded panel is reached from the truncation link and nowhere else. */
  openCandidatesPanelFor(item: IParseProduct): void {
    this.candidatesPanelProduct = item;
  }

  closeCandidatesPanel(): void {
    this.candidatesPanelProduct = null;
  }

  onApplyPriceFromTooltip(item: IParseProduct, event: { price: number; type: PriceSourceType }): void {
    // Defense in depth (WB-7024): the tooltip already hides its Apply
    // buttons for a no-price order (viewMode), but guard the entry point too.
    if (this.quotation?.all_lines_no_price) return;
    // The dialog exists to choose between this line and the whole order. When
    // the source has no bulk form there is no choice, and a modal that asks
    // nothing is a step the operator has to dismiss to get what they clicked.
    const canApplyToAll = supportsApplyToAllProducts(event.type);
    if (!canApplyToAll) {
      this.applyPriceToProducts([item], event);
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        title: this.translateService.instant(applyPriceTitleKey(event.type)),
        text: this.translateService.instant('quotations_and_orders.apply_price_confirmation_text'),
        show_cancel: false,
        show_third_btn: canApplyToAll,
        third_btn_text: this.translateService.instant('quotations_and_orders.all_products'),
        third_btn_class: 'secondary-btn',
        confirm_text: this.translateService.instant('quotations_and_orders.this_product'),
        confirm_class: 'btn-primary',
      },
    });

    dialogRef.afterClosed().subscribe((result: boolean | string) => {
      if (result === true) {
        this.applyPriceToProducts([item], event);
      } else if (result === 'third') {
        this.pendingApplyAllRefetch = true;
        this.store.dispatch(
          UpdateQuotationLines({
            id: this.quoteId,
            payload: { allProductsPriceType: event.type === 'ai' ? 'ai_price' : 'catalog_price' },
          })
        );
      }
    });
  }

  private applyPriceToProducts(products: IParseProduct[], event: { price: number; type: PriceSourceType }): void {
    const update = products
      .filter(p => p.order_line_id != null)
      .map(p => ({
        id: p.order_line_id!,
        // The price the caller emitted, never a stored column re-read here.
        // `event.price` is already the line's own ai_price / catalog_price for
        // those two sources; an observation or a history candidate has no
        // column to re-read, and falling back to `catalog_price` would write
        // the catalog price under the candidate's label.
        final_price: event.type === 'none' ? 0 : event.price,
        price_type: event.type,
      }));

    if (update.length === 0) return;

    this.store.dispatch(
      UpdateQuotationLines({
        id: this.quoteId,
        payload: { update },
      })
    );
  }

  // Ai analysis methods
  onIntentChange(event: Event): void {
    const intent = parseInt((event.target as HTMLSelectElement).value);
    this.intent = intent;
  }

  /** Template handler: select, and latch that the choice is now the USER's (WB-7399). */
  onAttachmentClick(attachmentUrl: string): void {
    this.userPickedAttachment = true;
    this.selectAttachment(attachmentUrl);
  }

  /** Programmatic selection (auto-select / re-select). Does NOT set the user latch. */
  private selectAttachment(attachmentUrl: string): void {
    this.selectedAttachmentUrl = attachmentUrl;
    // Create a new array reference to trigger change detection
    this.currentAttachment = [attachmentUrl];
  }

  /** Every line that can carry a `source` (WB-7399). */
  private orderSourceLines(): IOrderSourceLine[] {
    return [
      ...(this.productsQuote ?? []),
      ...(this.unmatchedProducts ?? []),
      ...(this.quotation?.ai_details?.matched_unmatched_order_lines ?? []),
    ];
  }

  /**
   * WB-7399: default the preview to the document the order lines were parsed from, else keep the
   * historical first-attachment default. Idempotent, so it is safe on every store emission.
   */
  private autoSelectPreviewAttachment(): void {
    const attachments = this.quotationSourceContent?.email?.attachments ?? [];
    if (attachments.length && this.selectedAttachmentUrl && !attachments.includes(this.selectedAttachmentUrl)) {
      // Matched by PATH, not exact URL: presigned URLs are re-signed on every refetch (Ask AI
      // re-dispatches GetQuotationSourceContent), so a byte-for-byte `includes` would treat the SAME
      // file as gone and discard a manual pick. Only when we actually know the new list — an empty
      // one is the "not resolved yet / borrowing from the parent" state.
      const key = attachmentPathKey(this.selectedAttachmentUrl);
      const resigned = key ? attachments.find((a) => attachmentPathKey(a) === key) : undefined;
      if (resigned) {
        this.selectedAttachmentUrl = resigned;
        this.currentAttachment = [resigned];
      } else {
        this.selectedAttachmentUrl = '';
        this.currentAttachment = [];
        this.userPickedAttachment = false;
        this.previewMatchLatched = false;
      }
    }
    if (this.userPickedAttachment || this.previewMatchLatched) {
      return;
    }
    const matched = findSourceAttachment(attachments, this.orderSourceLines()) ?? '';
    const url = matched || attachments[0] || '';
    if (url && url !== this.selectedAttachmentUrl) {
      this.selectAttachment(url);
    }
    this.previewMatchLatched = !!matched;
  }

  /**
   * Split children may have no documents of their own (see WB-7337 on the backend — older
   * splits, or any path that doesn't inherit message_id / source_attachment_provider_ids,
   * still land here). Front-end-only fallback: fetch the source order's own attachments and
   * merge just those in (see `withFallbackAttachments`), so the order details view always has
   * something to show. Called from every `quotation`/`quotationSourceContent` store emission,
   * so it's safe (and necessary) to call repeatedly — it only fetches while attachments are
   * still missing, which also covers a later re-fetch (e.g. after Ask AI) wiping them back out.
   * `emptySourceAttachmentIds` remembers a source order that came back with nothing, so a source
   * that will never have documents doesn't get re-fetched on every subsequent store emission.
   */
  private maybeLoadFallbackSourceAttachments(): void {
    const quotation = this.quotation;
    const sourceId = quotation?.segregation_info?.source_id;
    if (!quotation || !sourceId) {
      return;
    }
    if (this.quotationSourceContent?.email?.attachments?.length) {
      return;
    }
    if (this.emptySourceAttachmentIds.has(sourceId)) {
      return;
    }
    if (this.fallbackAttachmentsFetchInFlight) {
      return;
    }
    this.fallbackAttachmentsFetchInFlight = true;
    const forQuotationId = quotation.id;
    this.services.getFallbackSourceAttachments(sourceId).pipe(
      takeUntil(this.destroy$)
    ).subscribe((attachments) => {
      this.fallbackAttachmentsFetchInFlight = false;
      if (!attachments.length) {
        this.emptySourceAttachmentIds.add(sourceId);
        return;
      }
      // The page may have navigated to a different order by the time this resolves.
      if (this.quoteId !== forQuotationId) {
        return;
      }
      this.quotationSourceContent = withFallbackAttachments(this.quotationSourceContent, attachments);
      // A brand-new list of files: re-open the decision.
      this.previewMatchLatched = false;
      this.autoSelectPreviewAttachment();
    });
  }

  isAttachmentSelected(attachmentUrl: string): boolean {
    return this.selectedAttachmentUrl === attachmentUrl;
  }

  getAttachmentName(attachmentUrl: string): string {
    return attachmentFileName(attachmentUrl);
  }

  intentDisabled(): boolean {
    return this.quotation?.status === 'sale' || this.quotation?.status === 'done' || !!this.quotation?.is_archived;
  }

  // ── Add Product Search ──

  startAddProduct(): void {
    this.isAddProductMode = true;
    this.addProductQuery = '';
    this.store.dispatch(ClearProducts());
    setTimeout(() => {
      this.addProductInput?.nativeElement?.focus();
      this.addProductAutoTrigger?.openPanel();
    });
  }

  cancelAddProduct(): void {
    this.isAddProductMode = false;
    this.addProductQuery = '';
    this.store.dispatch(ClearProducts());
  }

  onAddProductSearch(event: Event): void {
    const value = (event.target as HTMLInputElement).value || '';
    this.addProductQuery = value;

    if (!value || value.length < 1) {
      this.store.dispatch(ClearProducts());
      this.isSearchLoading = false;
      return;
    }

    this.searchPage = 1;
    this.isSearchLoading = true;
    const filterRequest = {
      filters: [
        {
          key: 'status',
          operator: 'equals',
          value: 'Published'
        }
      ]
    };
    this.store.dispatch(
      FetchProductsBySearch({
        keyword: value,
        filter: filterRequest,
        includeDeals: false,
        page: { number: 1, size: 10 },
        append: false,
        skipGlobalLoader: true
      })
    );
  }

  onAddProductOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selected = event.option.value as IProduct;
    this.addProduct(selected);
  }

  loadMoreProducts(): void {
    if (this.isLoadingMore || !this.addProductQuery) return;
    if (!this.searchMetadata || this.searchPage >= this.searchMetadata.pages) return;

    this.isLoadingMore = true;
    this.isSearchLoading = true;
    this.searchPage++;
    const filterRequest = {
      filters: [
        {
          key: 'status',
          operator: 'equals',
          value: 'Published'
        }
      ]
    };
    this.store.dispatch(
      FetchProductsBySearch({
        keyword: this.addProductQuery,
        filter: filterRequest,
        includeDeals: false,
        page: { number: this.searchPage, size: 10 },
        append: true,
        skipGlobalLoader: true
      })
    );
  }

  onAutocompleteOpened(): void {
    setTimeout(() => {
      const panel = this.addProductAutoTrigger?.autocomplete?.panel?.nativeElement;
      if (panel) {
        panel.addEventListener('scroll', this.onPanelScroll);
      }
    });
  }

  onAutocompleteClosed(): void {
    const panel = this.addProductAutoTrigger?.autocomplete?.panel?.nativeElement;
    if (panel) {
      panel.removeEventListener('scroll', this.onPanelScroll);
    }
  }

  onPanelScroll = (): void => {
    const panel = this.addProductAutoTrigger?.autocomplete?.panel?.nativeElement;
    if (!panel) return;
    const threshold = 50;
    const atBottom = panel.scrollHeight - panel.scrollTop - panel.clientHeight < threshold;
    if (atBottom && !this.isLoadingMore) {
      this.loadMoreProducts();
    }
  };

  onAddProductKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Tab') return;
    if (!this.addProductAutoTrigger?.panelOpen) return;

    const km = (this.addProductAutoTrigger.autocomplete as any)?._keyManager;
    const active = km?.activeItem;
    const selected = active?.value as IProduct | undefined;
    if (!selected) return;

    event.preventDefault();
    this.addProduct(selected);
  }

  private addProduct(product: IProduct): void {
    const newProductId = (product.id ?? product.product_id) as number | undefined;
    if (!newProductId) return;

    const newProduct = {
      product_id: newProductId,
      quantity: product.min_qte || 1,
      added_manually: true,
    }

    this.scrollToLastAfterAdd = true;
    this.suppressScrollLoadUntil = Date.now() + 2000;
    this.store.dispatch(UpdateQuotationLines({
          id: this.quoteId, payload: {
          add: [
            newProduct
          ]
        }
     }));
    this.cancelAddProduct();
  }

}
